import kit from '@binaa-almajal/ui-kit/locales/kit/fr';

// French. Must carry the same keys as en.js — a missing key silently falls back
// to English mid-sentence, which reads as a bug rather than a gap.
//
// Apostrophes are the typographic ’ throughout, not the straight ', so the
// strings need no escaping inside single quotes. French is LTR, so no logical
// property work is needed beyond what ar.js already forced.

// See en.js: the kit's own copy first, this application's keys after.
export default {
    ...kit,
    // ─── Application ─────────────────────────────────────────────────────────
    'app.name': 'VDC Academy',
    'app.logoAlt': 'Logo de Binaa Al-Majal',

    // ─── Marque ──────────────────────────────────────────────────────────────
    // Le nom de la société tel qu’il figure sur le logo ; il ne se traduit pas.
    'brand.name': 'Binaa Al-Majal',
    'brand.tagline': 'Construire plus intelligemment. Modéliser mieux. Livrer l’avenir.',
    'brand.discipline': 'Construction numérique',

    // ─── Navigation ──────────────────────────────────────────────────────────
    'nav.dashboard': 'Tableau de bord',
    'nav.people': 'Personnes',
    'nav.cohorts': 'Promotions',
    'nav.arrivals': 'Arrivées',
    'nav.cohortRequests': 'Demandes de promotion',
    'nav.grading': 'Notation',
    'nav.enrollmentsQueue': 'En attente de clôture',
    'nav.credentials': 'Certifications',
    'nav.curriculum': 'Cursus',
    'nav.my': 'Ma formation',
    'nav.my.what': 'Quoi faire ensuite, et ce qui est dû',
    'nav.group.home': 'Accueil',
    'nav.group.queues': 'Files d’attente',
    'nav.group.register': 'Inscriptions',
    'nav.group.catalogue': 'Catalogue',

    // ─── Ce que contient chaque entrée de la barre latérale ──────────────────
    'nav.dashboard.what': 'La journée en bref',
    'nav.company.what': 'Vos places et vos personnes',
    'nav.arrivals.what': 'Nouveaux apprenants',
    'nav.cohortRequests.what': 'Entreprises en attente de dates',
    'nav.grading.what': 'Travaux en attente de verdict',
    'nav.enrollmentsQueue.what': 'Personnes ayant terminé et non encore clôturées',
    'nav.people.what': 'Toutes les personnes enregistrées',
    'nav.cohorts.what': 'Les programmes en cours',
    'nav.availability': 'Disponibilité',
    'nav.availability.what': 'Qui est absent, selon les RH',
    'nav.credentials.what': 'Qui détient quoi',
    'nav.companies.what': 'Qui achète les places',
    'nav.curriculum.what': 'Ce que nous enseignons',
    'nav.programs.what': 'Ce que nous vendons',
    'nav.checkCodes.what': 'Ce qu’un évaluateur peut citer',

    // ─── Le fil du catalogue ─────────────────────────────────────────────────
    'pipeline.curriculum': 'Niveaux, modules, leçons',
    'pipeline.programs': 'Modules réunis pour la vente',
    'pipeline.cohorts': 'Un programme réellement dispensé',
    'nav.group.system': 'Système',
    'nav.openGroup': 'Afficher tout ce qui relève de {name}',
    'nav.expand': 'Déployer la barre latérale',
    'nav.menu': 'Ouvrir la navigation',

    // ─── Identité ────────────────────────────────────────────────────────────
    'auth.signIn': 'Se connecter',
    'auth.signOut': 'Se déconnecter',
    'auth.signInRequired': 'Connectez-vous pour continuer.',

    'auth.gateLead': 'Formation, évaluation et certification pour la plateforme Binaa.',
    'auth.gateTitle': 'Connectez-vous pour continuer',
    'auth.gateSignInHint': 'Vous serez redirigé vers la page de connexion de l’Académie pour saisir vos identifiants.',
    'auth.gateNoProvider': 'Aucun fournisseur de connexion n’est configuré pour cette version.',
    'auth.noAccountTitle': 'Pas encore de compte ?',
    'auth.noAccountEnquiryHint': 'Les comptes sont créés par l’Académie. Contactez-nous et notre équipe s’occupe de tout.',
    'auth.getInTouch': 'Nous contacter',
    'auth.haveAccount': 'Vous avez déjà un compte ?',
    'auth.gateVerify': 'Vérifier le certificat',
    'auth.notProvisioned':
        'Votre compte n’est pas encore rattaché à une fiche personne. Demandez à un administrateur de le rattacher — vous reconnecter n’y changera rien.',
    'auth.notProvisionedTitle': 'Votre compte doit être rattaché',
    'auth.notProvisionedQuote': 'Communiquez cette identité à l’administrateur :',
    'auth.claimHint':
        'Vous avez candidaté et été accepté ? Si vous vous êtes connecté avec l’adresse e-mail de votre candidature, vous pouvez récupérer vos dossiers vous-même.',
    'auth.claimAction': 'Récupérer mes dossiers',
    'auth.claimNotFound':
        'Aucune candidature acceptée ne correspond à cette adresse e-mail. Si vous avez candidaté avec une autre adresse, demandez plutôt à un administrateur de rattacher votre compte.',
    'error.generic': 'Une erreur est survenue.',

    // ─── Commun ──────────────────────────────────────────────────────────────
    'common.save': 'Enregistrer',
    'common.delete': 'Supprimer',
    'common.closeModal': 'Fermer la boîte de dialogue',
    'common.backHome': 'Retour au tableau de bord',
    'common.toggleTheme': 'Changer de thème',
    'common.or': 'ou',

    // ─── Marchés ─────────────────────────────────────────────────────────────
    'market.select': 'Choisir un pays…',
    'market.none': 'Aucun pays disponible',
    'market.allMarkets': 'Aucun pays sélectionné — disponible partout',
    'market.label': 'Pays',
    'market.add': 'Ajouter un pays…',
    'market.remove': 'Retirer {code}',
    'market.all': 'Tous les pays',
    'countryFilter.label': 'Filtrer par pays',
    'countryFilter.all': 'Tous les pays',

    'person.languageNotSet': 'Non renseignée',
    'person.languageUnsupported': 'langue non prise en charge',
    'common.user': 'Utilisateur',
    'common.userMenu': 'Menu utilisateur',
    'common.yes': 'Oui',
    'common.no': 'Non',
    'common.uploading': 'Envoi en cours…',

    'action.close': 'Fermer',

    // ─── Dashboard ─────────────────────────────────────────────────────────────
    'dashboard.purpose': "Ce qui a besoin de votre attention, et comment y répondre.",
    'screen.dashboard.intro': "Ce qui a besoin de votre attention — commencez par « Pour vous », puis les files ci-dessous.",
    'screen.cohorts.intro': "Les programmes en cours — ouvrez-en un pour voir sa liste, ses dates et son formateur.",
    'dashboard.people': 'Personnes',
    'dashboard.learners': 'Apprenants',
    'dashboard.instructors': 'Formateurs',
    'dashboard.myLearners': 'Mes apprenants',
    'dashboard.myLearnersHint': 'Sur les promotions que vous enseignez',
    'dashboard.myTeachingStatus': 'Statut d’enseignement',
    'dashboard.teachingNow': 'En cours d’enseignement',
    'dashboard.notTeaching': 'N’enseigne pas actuellement',
    'dashboard.gradingQueue': 'En attente de notation',
    'dashboard.outboxDepth': 'Profondeur de la file d’envoi',
    'dashboard.outboxHint': 'Événements d’intégration en attente d’écoulement',
    'dashboard.cohortsByState': 'Promotions par état',
    'dashboard.enrollmentsByState': 'Inscriptions par état',
    'dashboard.credentialsByStatus': 'Certifications par statut',
    'dashboard.noCohortsYet': 'Aucune promotion pour l’instant',
    'dashboard.noEnrollmentsYet': 'Aucune inscription pour l’instant',
    'dashboard.noCredentialsYet': 'Aucune certification pour l’instant',
    'dashboard.total': 'Total',
    'dashboard.openCohorts': 'Ouvrir le registre des promotions',
    'dashboard.programScoringTitle': '{count} programmes n’ont aucune notation de module',
    'dashboard.programScoringTitleOne': '1 programme n’a aucune notation de module',
    'dashboard.programScoringBody': 'Leur seuil de programme ne fixe aucune note minimale : les titres n’exigent donc que des réussites. Fixez une note minimale sur les modules qui doivent en exiger une.',
    'dashboard.programScoringCta': 'Définir la notation des modules',
    'dashboard.queues': 'En attente d’une décision',
    'dashboard.queueEmpty': 'Rien en attente',
    'dashboard.gradingQueueHint': 'Évaluations en attente d’un formateur',
    'dashboard.awaitingCompletionQueue': 'En attente de clôture',
    'dashboard.awaitingCompletionQueueHint':
        'A terminé tous les modules, sans être marqué comme terminé',
    'dashboard.delivery': 'Prestation',
    'dashboard.hoursTaught': 'Heures enseignées',
    'dashboard.hoursTaughtHint': 'Sur {held} séances tenues',
    'dashboard.sessionsHeld': 'Séances tenues',
    'dashboard.lastHeld': 'Dernière séance {when}',
    'dashboard.neverHeld': 'Aucune séance tenue',
    'dashboard.attendanceRate': 'Présence',
    'dashboard.noRegisters': 'Aucune feuille de présence',
    'dashboard.attendanceBasis': '{present} sur {expected}, sur {registers} feuilles',
    'dashboard.cancellationRate': 'Annulations',
    'dashboard.nothingDecided': 'Aucune séance tenue ni annulée',
    'dashboard.cancellationBasis': '{cancelled} annulées · {scheduled} à venir',
    'dashboard.instructorsTeaching': 'En cours d’enseignement',
    'dashboard.instructorsTeachingHint': 'Assignés à une promotion active',
    'dashboard.instructorsDelisted': 'Retirés',
    'dashboard.instructorsDelistedHint': 'Ne prennent plus de promotions',
    'dashboard.satisfaction': 'Satisfaction',
    'dashboard.unrated': 'Pas encore noté',
    'dashboard.outOfTen': '{score} / 10',
    'dashboard.ratingsCount': '{count} avis',
    'dashboard.sessionsAhead': 'Programmées',
    'dashboard.sessionsAheadHint': 'Séances encore à tenir',
    'dashboard.sessionsByOutcome': 'Séances par issue',
    'dashboard.instructorDelivery': 'Formateurs, par prestation',
    'dashboard.instructorDeliveryLead':
        'Qui a enseigné, combien, et comment cela s’est passé. Les formateurs retirés restent dans la liste et se classent en dernier — un historique de prestation ne disparaît pas quand quelqu’un cesse d’enseigner.',
    'dashboard.noInstructors': 'Aucun formateur n’a encore enseigné ici',
    'dashboard.noInstructorsHint':
        'Un formateur apparaît dès qu’une promotion de ce marché le désigne.',
    'dashboard.delisted': 'Retiré',
    'dashboard.heldOfScheduled': '{held} tenues · {ahead} à venir',
    'dashboard.cancelled': 'Annulées',
    'dashboard.cancelledCount': '{count} ({rate})',
    'dashboard.cohortsTaught': 'Promotions',
    'dashboard.cohortsRunningOf': '{total}, dont {running} en cours',
    'dashboard.learnersTaught': 'Personnes formées',
    'dashboard.lastTaught': 'Dernier cours',

    // ─── Vérification publique ───────────────────────────────────────────────
    'verify.title': 'Vérifier un certificat',
    'verify.subtitle': 'Saisissez le numéro imprimé sur le certificat. Aucun compte n’est nécessaire.',
    'verify.placeholder': 'Numéro de certificat',
    'verify.submit': 'Vérifier',
    'verify.notFound': 'Aucun certificat ne correspond à ce numéro.',
    'verify.rateLimited': 'Trop de vérifications depuis ce réseau. Attendez une minute et réessayez.',
    'verify.publicNo': 'Numéro de certificat',
    'verify.issuer': 'Délivré par',
    'verify.issuedOn': 'Délivré le',
    'verify.validUntil': 'Valable jusqu’au',
    'verify.competencies': 'Compétences',

    'credential.status.Active': 'Active',
    'credential.status.Expired': 'Expirée',
    'credential.status.Revoked': 'Révoquée',
    'credential.status.Superseded': 'Remplacée',

    // ─── Erreurs ─────────────────────────────────────────────────────────────
    'error.not_found': 'Cet enregistrement n’existe plus.',
    'error.conflict': 'Cette modification entre en conflit avec l’état actuel.',
    'error.validation': 'La demande a été rejetée.',
    'error.forbidden': 'Vous n’avez pas l’autorisation de faire cela.',
    'error.seat_capacity': 'Cette promotion est complète.',
    'error.curriculum_frozen': 'Cette version du cursus est figée par une promotion — sa structure, ses crédits et ses notes de passage ne peuvent plus changer. Les leçons, les supports et les énoncés restent modifiables.',
    'error.instructor_delisted': 'Vous êtes le formateur assigné, mais votre statut est radié. Une nouvelle certification rétablit la rédaction.',
    'error.cohort_closed': 'Cette promotion est terminée ou annulée — son contenu de diffusion est en lecture seule.',
    'error.quiz_unconfigured': 'Ce quiz n’est pas prêt à être passé — prévenez votre coordinateur.',
    'error.requirements_unmet': 'Le seuil du programme n’est pas atteint.',
    'error.program_unconfigured': 'Ce programme n’a aucun module obligatoire : il n’y a donc pas de seuil pour délivrer un titre.',
    'error.already_enrolled': 'Cette personne est déjà inscrite à cette promotion.',
    'error.not_confirmable': 'Cette évaluation n’est pas dans un état confirmable.',
    'error.ai_unavailable': 'La rédaction assistée par IA est indisponible.',
    'error.ai_quota_reached': 'La limite d’utilisation de l’IA pour cette période est atteinte. Réessayez plus tard, ou continuez manuellement.',
    'error.artifact_unavailable': 'Le stockage de fichiers n’est pas configuré sur ce déploiement.',
    'error.live_unavailable': 'Les classes en direct ne sont pas configurées sur ce déploiement.',
    'error.credential_lapsed': 'Cette certification est échue.',
    'error.stale_write': 'Quelqu’un a enregistré avant vous. Rechargez, réappliquez votre modification, puis enregistrez à nouveau.',
    'error.idempotency_mismatch': 'Cette requête ne peut pas être réessayée. Rechargez la page et recommencez.',
    'error.actor_unmatched':
        'Votre compte n’est pas rattaché à une fiche personne. Demandez à un administrateur de le rattacher.',

    'error.unauthenticated': 'Votre session n’est plus valide. Reconnectez-vous.',
    'error.rate_limited': 'Trop de requêtes. Veuillez patienter un instant.',
    'error.model_binding': 'Certains champs ont été rejetés avant que la requête n’atteigne le serveur.',
    'error.network': 'Le serveur est injoignable.',

    'error.pageNotFound': 'Cette page est introuvable.',

    // ─── Connexion réseau ────────────────────────────────────────────────────
    'connection.noInternet': 'Aucune connexion internet',
    'connection.serverUnreachable': 'Impossible de joindre l’Académie',
    'connection.serverUnreachableDesc': 'Le serveur ne répond pas. Il est peut-être en cours de redémarrage.',
    'connection.retrying': 'Tentative…',

    // ─── Validation ──────────────────────────────────────────────────────────
    'validation.fieldRequired': '{field} est obligatoire',
    'validation.emailInvalid': 'Saisissez une adresse e-mail valide',
    'validation.nameMinLength': '{field} doit comporter au moins 2 caractères',
    'validation.nameLettersOnly': '{field} ne peut contenir que des lettres, des espaces, des traits d’union et des apostrophes',
    'validation.nameLatin': 'Saisissez le nom en lettres latines — les certificats sont émis en anglais et l’impriment exactement tel qu’il est écrit ici.',
    'validation.minLength': 'Doit comporter au moins {min} caractères',
    'validation.maxLength': 'Ne doit pas dépasser {max} caractères',
    'validation.invalidNumber': '{field} doit être un nombre valide',
    'validation.fieldPositive': '{field} doit être supérieur à 0',
    'validation.fieldDate': '{field} doit être une date valide',
    'validation.invalidPhone': 'Saisissez un numéro de téléphone valide',
    'phone.countryLabel': 'Pays et indicatif téléphonique',
    'phone.numberPlaceholder': 'Numéro de téléphone',
    'phone.noCountry': 'Aucun pays',
    'validation.invalidUrl': 'Saisissez une URL valide',
    'validation.fileType': 'Le type de fichier doit être l’un des suivants : {types}',
    'validation.fileSize': 'Le fichier doit faire moins de {size} Mo',

    // ─── Kit de composants ───────────────────────────────────────────────────
    'search.placeholder': 'Rechercher…',
    'search.group.screens': 'Ecrans',
    'search.group.tabs': 'Onglets',
    'search.group.people': 'Personnes',
    'search.group.cohorts': 'Cohortes',




    'date.pick': 'Choisir une date',
    'date.today': 'Aujourd’hui',
    'date.tomorrow': 'Demain',
    'date.yesterday': 'Hier',

    'uploadForm.chooseFile': 'Choisir un fichier',
    'uploadForm.dropFile': 'Déposez un fichier ici',
    'uploadForm.uploadFile': 'Envoyer',
    'uploadForm.downloadTemplate': 'Télécharger le modèle',
    'uploadForm.templateText': 'Utilisez le modèle pour que les colonnes correspondent.',

    // ─── Kit domaine — états du cycle de vie ─────────────────────────────────
    'state.draft': 'Brouillon',
    'state.filling': 'En remplissage',
    'state.confirmed': 'Confirmée',
    'state.running': 'En cours',
    'state.completed': 'Terminée',
    'state.cancelled': 'Annulée',
    'state.invited': 'Invité',
    'state.active': 'Actif',
    'state.withdrawn': 'Retiré',
    'state.failed': 'Échoué',
    'state.awaitingInstructor': 'En attente du formateur',
    'state.returned': 'Renvoyé',
    'state.expired': 'Expiré',
    'state.revoked': 'Révoqué',
    'state.superseded': 'Remplacé',
    'state.submitted': 'Soumis',
    'state.approved': 'Approuvé',
    'state.rejected': 'Rejeté',
    'state.awaitingApproval': 'En attente d’approbation',
    'state.pending': 'En attente',
    'state.passed': 'Réussi',
    'state.notReady': 'Non apte',
    'state.conditionallyReady': 'Apte sous conditions',
    'state.ready': 'Apte',
    'state.notStarted': 'Non commencé',
    'state.inProgress': 'En cours',
    'state.notAttempted': 'Non tenté',
    'state.waived': 'Dispensé',

    // ─── Kit domaine — résultats des lots ────────────────────────────────────
    'batch.allSucceeded': 'Les {count} éléments ont tous réussi',
    'batch.partialFailure': '{failed} éléments sur {total} ont échoué',

    // ─── Kit domaine — écriture périmée ──────────────────────────────────────
    'staleWrite.title': 'Quelqu’un a enregistré avant vous',
    'staleWrite.hint': 'Rechargez pour obtenir sa version — vos modifications non enregistrées restent dans le formulaire, vous pouvez les revoir et enregistrer à nouveau.',
    'staleWrite.reload': 'Recharger l’enregistrement',

    'problem.traceId': 'Identifiant de trace : {traceId}',

    // ─── Kit domaine — compétence ────────────────────────────────────────────
    'competency.trainingProgress': 'Progression de la formation',
    'competency.trainingProgressHint': 'Contenu consulté — pas une revendication de compétence',
    'competency.passedCreditRatio': 'Ratio de crédits validés',
    'competency.passedCreditRatioHint': 'Crédits validés sur crédits évaluables',
    'competency.mandatoryOutstanding': 'Des modules obligatoires restent à valider.',
    'competency.noModulesOnTrack': 'Aucun module dans cette filière',
    'competency.progressShort': 'Progression',
    'competency.passedShort': 'Validés',
    'competency.modulesShort': 'Modules',
    'competency.noModules': 'Aucun module pour l’instant',
    'competency.noModulesHint': 'Le programme de la promotion n’a aucun module rattaché. Les lignes de modules apparaissent une fois le programme configuré.',
    'competency.module': 'Module',
    'competency.completion': 'Achèvement',
    'competency.assessment': 'Évaluation',
    'competency.bestScore': 'Meilleure note',
    'competency.credits': 'Crédits',
    'competency.notAssessedModule': 'Non évalué',

    // ─── Kit domaine — seuil du programme ────────────────────────────────────────
    'programBar.title': 'Seuil du programme',
    'programBar.meets': 'Atteint le seuil du programme',
    'programBar.notYet': 'Pas encore',
    'programBar.unconfigured': 'Aucun seuil défini',
    'programBar.unconfiguredHint': 'Ce programme n’a aucun module obligatoire : il n’y a donc pas encore de seuil à atteindre. Un administrateur le définit sur le programme.',
    'programBar.unmetHeading': 'Reste à valider',
    'programBar.unmetCount': '{count} module(s) en attente',
    'programBar.reasonNotPassed': 'non réussi',
    'programBar.reasonScore': 'note {actual} inférieure à {required}',
    'programBar.reasonNoScore': 'pas encore de note (requis : {required})',
    'programBar.reasonCapstone': 'projet final manquant',

    // ─── Pagination par curseur ──────────────────────────────────────────────

    // ─── Colonnes du registre des promotions ─────────────────────────────────
    'cohort.code': 'Code',
    'cohort.program': 'Programme',
    'cohort.market': 'Pays',
    'cohort.state': 'État',
    'cohort.fill': 'Places',
    'cohort.startsOn': 'Début',
    'cohort.instructor': 'Formateur',
    'cohort.searchPlaceholder': 'Rechercher une cohorte par code ou programme…',
    'cohort.stateAll': 'Tous les états',
    'cohort.unstaffedOnly': 'Sans formateur',
    'cohort.noneMatch': 'Aucune cohorte ne correspond',
    'cohort.noneMatchHint': 'Effacez la recherche ou les filtres pour voir tout le registre.',
    'cohort.statTotal': 'Cohortes',
    'cohort.statRunning': 'En cours',
    'cohort.statFilling': 'En remplissage',
    'cohort.statUnstaffed': 'Sans formateur',

    // ─── Apprenant 360 ───────────────────────────────────────────────────────
    'trainee.title': 'Apprenant 360',
    'trainee.enrolledAt': 'Inscrit le {date}',
    'trainee.dimensions': 'Dimensions',
    'trainee.modules': 'Modules',

    // ─── Détail d’une inscription ────────────────────────────────────────────
    'enrollment.title': 'Inscription',
    'enrollment.completedAt': 'Terminée le {date}',
    'enrollment.dualCredit': 'Double crédit',

    // ─── Personnes ───────────────────────────────────────────────────────────
    'person.fullName': 'Nom',
    'person.fullNameLatinHint': 'En lettres latines, exactement comme il doit apparaître sur les certificats.',
    'person.email': 'E-mail',
    'person.market': 'Pays',
    'person.preferredLanguage': 'Langue préférée',
    'person.kindLearner': 'Apprenants',
    'person.kindManager': 'Responsables entreprise',
    'person.kindInstructor': 'Formateurs',
    'person.kindUnaffiliated': 'Sans rattachement',
    'person.statTotal': 'Personnes',
    'person.statLearners': 'Apprenants',
    'person.statInstructors': 'Formateurs',
    'person.statUnaffiliated': 'Sans rattachement',
    'person.company': 'Entreprise',
    'person.profiles': 'Profils',
    'person.learner': 'Apprenant',
    'person.instructor': 'Formateur',
    'person.identity': 'Identité de connexion',
    'person.identityLinked': 'Rattachée',
    'person.identityNotLinked': 'Non rattachée — personne ne peut se connecter en tant que cette personne',
    // ─── Arrivées ────────────────────────────────────────────────────────
    'arrivals.subtitleHrm': 'Ce que le SIRH a affecté — des employés internes envoyés en formation ou nommés formateurs. Émettez leur connexion, puis placez les apprenants dans une promotion.',
    'arrivals.subtitle': 'Ce que a transmis — vérifiez la personne ou l’entreprise, émettez leurs identifiants, puis inscrivez-les selon l’offre confirmée.',
    'arrivals.total': 'Arrivées',
    'arrivals.totalHint': 'Toutes portes, sous le filtre actuel',
    'arrivals.awaitingAdmissionCount': 'En attente d’admission',
    'arrivals.awaitingAdmissionHint': 'Paiement confirmé, admission à finaliser',
    'arrivals.notPlacedCount': 'Pas encore placé',
    'arrivals.notPlacedHint': 'Peut se connecter, dans aucune cohorte',
    'arrivals.loginIssuedCount': 'Accès délivré',
    'arrivals.loginIssuedHint': 'Sur {total} affichés',
    'arrivals.received': 'Reçu',
    'arrivals.who': 'Qui',
    'arrivals.kind': 'Compte',
    'arrivals.person': 'Personne',
    'arrivals.company': 'Entreprise',
    'arrivals.instructor': 'Formateur',
    'arrivals.learner': 'Apprenant',
    'arrivals.role': 'Arrivé comme',
    'arrivals.sourceAll': 'Toutes les portes',
    'arrivals.sourceCrm': 'Via les ventes',
    'arrivals.sourceHrm': 'Via l\u2019employeur',
    'arrivals.sourceAcademy': 'Achat direct',
    'arrivals.all': 'Tous',
    'arrivals.people': 'Personnes',
    'arrivals.companies': 'Entreprises',
    'arrivals.universities': 'Universités',
    'arrivals.university': 'Université',
    'arrivals.seats': '{count} places',
    'arrivals.deal': 'Affaire',
    'arrivals.access': 'Accès',
    'arrivals.loginIssued': 'Identifiants émis',
    'arrivals.placed': 'Affecté à',
    'arrivals.seatsPlaced': '{placed} sièges sur {seats} affectés',
    'arrivals.notPlaced': 'Pas encore affecté',
    'arrivals.notPlacedYet': "Pas encore affecté à une cohorte — affectez-le avant sa connexion, sinon il ne trouvera rien à suivre.",
    'arrivals.invited': 'Invité',
    'arrivals.offer': 'Offre',
    'arrivals.searchPlaceholder': 'Rechercher par nom, e-mail ou affaire…',
    'arrivals.empty': 'Aucune arrivée pour l’instant',
    'arrivals.emptyHint': 'Les demandes converties et les affaires gagnées arrivent ici en temps réel.',
    'arrivals.emptyHintHrm': 'Les employés que le SIRH affecte à une formation — ou nomme formateurs — arrivent ici en temps réel.',
    'arrivals.offerTitle': 'Offre — {name}',
    'arrivals.requirements': 'Exigences',
    'arrivals.programs': 'Programmes',
    'arrivals.modules': 'Modules',
    'arrivals.moduleVerified': 'Vérifié',
    'arrivals.moduleUnverified': 'Non vérifié',
    'arrivals.attachments': 'Pièces jointes (conservées dans)',
    'arrivals.offerEmpty': 'L’offre ne porte aucun détail structuré.',

    'person.emptyList': 'Aucune personne pour l’instant',
    'person.searchPlaceholder': 'Rechercher par nom ou e-mail…',
    'person.newArrival': 'Nouveau',
    'person.newArrivalsBanner': '{count} nouvelles arrivées attendent leurs identifiants — examinez-les.',
    'person.signInAccess': 'Accès au compte',
    'person.signInActive': 'Peut se connecter',
    'person.signInNone': 'Pas encore de connexion',
    'person.signInActiveHint': 'Cette personne a un compte et se connecte avec son adresse e-mail.',
    'person.signInNoneHint': 'Émettez des identifiants pour créer son compte : elle reçoit son adresse e-mail et un mot de passe provisoire, changé à la première connexion.',
    'person.signInNoneAutoLink': 'Lorsque cette personne se connectera, elle sera liee automatiquement par son adresse e-mail.',
    'person.issueSignIn': 'Émettre les identifiants',
    'person.resetSignIn': 'Réinitialiser le mot de passe',
    'person.signInIssuedLead': 'Le compte de {email} est prêt. Son mot de passe provisoire :',
    'person.copy': 'Copier',
    'person.copied': 'Copié',
    'person.signInEmailQueued': 'Les mêmes informations lui ont été envoyées par e-mail.',
    'person.signInIssuedOnce': 'Le mot de passe n’apparaît que cette fois et doit être changé à la première connexion.',
    'person.identityAdvanced': 'Avancé : lier une identité existante',
    'person.emptyListHint': 'Les personnes sont créées en acceptant une candidature, ou directement par le service des inscriptions.',
    'person.learnerProfile': 'Profil apprenant',
    'person.instructorProfile': 'Profil formateur',
    'person.upgradedAt': 'Migré le',
    'person.crmAccount': 'Compte',
    'person.tier': 'Grade',
    'person.nps': 'NPS',
    'person.certifiedAt': 'Certifié le',
    'person.delistedAt': 'Radié le',
    'person.instructorInactive': 'Inactif',
    'person.noProfiles': 'Aucun profil apprenant ni formateur — une forme normale pour un administrateur.',
    'person.tabProfile': 'Profil',
    'person.tabCredentials': 'Certifications',

    'learnerTrack.internalHire': 'Recrutement interne',
    'learnerTrack.external': 'Externe',
    'instructorKind.founder': 'Fondateur',
    'instructorKind.dualHat': 'Double casquette',
    'instructorKind.certifiedTrainer': 'Formateur certifié',
    'trainerTier.associate': 'Associé',
    'trainerTier.professional': 'Professionnel',
    'trainerTier.master': 'Maître',

    // ─── Certifications (vue titulaire) ──────────────────────────────────────
    'credential.emptyForHolder': 'Aucune certification',
    'credential.emptyForHolderHint': 'Les certifications délivrées à cette personne apparaissent ici, y compris celles révoquées et expirées.',
    'credential.issuedOn': 'Délivrée le',
    'credential.validUntil': 'Valable jusqu’au',

    // ─── Aptitude (onglet personne) ──────────────────────────────────────────

    // ─── Audit ───────────────────────────────────────────────────────────────
    'availability.title': 'Disponibilité des formateurs',
    'availability.subtitle': 'Absences approuvées, telles que les énonce le système RH. Rien ici ne bloque une réservation — une séance posée sur une absence est un avertissement à lire, pas une écriture refusée.',
    'availability.from': 'Du',
    'availability.to': 'Au',
    'availability.person': 'Personne',
    'availability.startDate': 'Premier jour d’absence',
    'availability.endDate': 'Dernier jour d’absence',
    'availability.statedAt': 'Énoncé le',
    'availability.statTotal': 'Absences dans la période',
    'availability.statCurrentlyAway': 'Absents aujourd’hui',
    'availability.statInstructors': 'Formateurs concernés',
    'availability.statUnlinked': 'Non liés à quelqu’un ici',
    'availability.notLinked': 'Rattaché à personne ici',
    'availability.lastApplied': 'Dernière livraison {when} ({ago}), {count} absences énoncées.',
    'availability.empty': 'Personne n’est absent sur cette période',
    'availability.emptyHint': 'Le flux a livré — période calme, et non période manquante.',
    'availability.neverDelivered': 'Aucune absence n’a jamais été livrée',
    'availability.neverDeliveredHint': 'Le système RH n’a jamais énoncé d’absence à cette Academy : une liste vide ici ne veut donc rien dire.',

    // ─── Écritures sur les personnes ─────────────────────────────────────────
    'person.emailOptional': 'Facultatif — une personne peut exister sans e-mail.',
    'person.marketHint': 'Le pays de la personne.',
    'person.clearableHint': 'Laissez vide et enregistrez pour vider ce champ — le vider écrit NULL, délibérément.',
    'person.clearField': 'Vider',
    'person.noLearnerProfile': 'Aucun profil apprenant. En rattacher un est ce qui rend cette personne inscriptible.',
    'person.noInstructorProfile': 'Aucun profil formateur. Les formateurs sont affectés depuis la GRH, pas depuis cet écran.',
    'person.learnerTrack': 'Filière',
    'person.crmAccountHint': 'Identifiant crm.account facultatif pour un apprenant en entreprise.',
    'person.identityLink': 'Rattachement de l’identité de connexion',
    'person.identityLinkedTo': 'Rattachée à l’identifiant utilisateur',
    'person.identityUserId': 'Identifiant utilisateur',
    'person.identityLinkHint': 'Enregistre QUI est le sujet d’un jeton — cela n’accorde rien (les rôles vivent dans Keycloak), et corrige un appelant bloqué sur « compte non rattaché ».',
    'person.linkIdentity': 'Rattacher',
    'person.rateInstructor': 'Noter le formateur',
    'person.ratingCohort': 'ID de la promotion',
    'person.ratingScore': 'Note (0–10)',
    'person.ratingScoreHint': 'Ajout uniquement : une correction est une nouvelle note, jamais une modification.',
    'person.ratingComment': 'Commentaire',
    'person.ratingSource': 'Source',
    'person.submitRating': 'Envoyer la note',
    'person.recordAudit': 'Consigner un audit',
    'person.auditReviewedAt': 'Examiné le',
    'person.auditOutcome': 'Résultat',
    'person.auditDelistWarning': 'La radiation marque aussi le profil formateur, dans la même transaction.',
    'person.auditFindings': 'Constats',
    'person.submitAudit': 'Consigner le résultat',

    'inputSource.instructor': 'Formateur',
    'inputSource.lms': 'LMS',
    'inputSource.import': 'Import',
    'inputSource.selfReported': 'Déclaré par l’apprenant',
    'auditOutcome.passed': 'Réussi',
    'auditOutcome.coached': 'Accompagné',
    'auditOutcome.downTiered': 'Rétrogradé',
    'auditOutcome.delisted': 'Radié',

    // ─── Promotions ──────────────────────────────────────────────────────────
    'cohort.create': 'Nouvelle promotion',
    'cohort.emptyListHint': 'Créez la première promotion pour commencer à remplir les places.',
    'cohort.availability': 'Disponibilité',
    'cohort.seatsAvailable': '{count} places disponibles',
    'cohort.notAccepting': 'N’accepte pas d’inscriptions',
    'cohort.curriculum': 'Cursus',
    'cohort.selectCurriculumFirst': 'Sélectionnez un cursus d’abord.',
    'cohort.curriculumVersion': 'Version du cursus',
    'cohort.currentVersion': '{label} (actuelle)',
    'cohort.pinFreezesVersion': 'Créer cette promotion épingle la version du cursus sélectionnée et fige sa STRUCTURE — niveaux, modules, crédits et notes de passage seront refusés à partir de là. Les leçons, les supports et les énoncés de devoir restent modifiables.',
    'cohort.format': 'Format',
    'cohort.sourcing': 'Origine',
    'cohort.deliveryLayer': 'Mode de diffusion',
    'cohort.seats': 'Places',
    'cohort.statFilled': 'Occupées',
    'cohort.statFilledOf': '{filled} sur {seats}',
    'cohort.statActive': 'Actifs',
    'cohort.statFinished': 'Terminés',
    'cohort.statSeatsOpen': 'Places disponibles',
    'cohort.seating': 'Lieu',
    'cohort.seatingHint': "Quelle salle et quels postes. Le registre des actifs n'est informé des postes de labo que pour les cohortes enseignées dans nos locaux.",
    'cohortSeating.unstated': 'Non précisé',
    'cohortSeating.remote': 'À distance',
    'cohortSeating.academyPremises': 'Nos locaux',
    'cohortSeating.clientPremises': 'Locaux du client',
    'cohort.endsOn': 'Fin',
    'cohort.instructorOptional': 'Facultatif — une promotion en brouillon sans formateur est normale.',
    'cohort.versionNotEditable': 'Épinglée sur {label}. La version du cursus n’est volontairement pas modifiable — la réépingler recalculerait les notes des apprenants.',
    'cohort.moveTo': 'Passer à :',
    'cohort.viewList': 'Liste',
    'cohort.viewBoard': 'Tableau',
    'cohort.boardDropHere': 'Déposez les promotions ici',
    'cohort.moveToAria': 'Déplacer {code} vers un autre état',
    'cohort.everyoneFinished': 'Les {count} apprenants ont tous terminé. Clôturer cette promotion ?',
    'cohort.everyoneFinishedShort': 'Tous les apprenants ont terminé',
    'cohort.completeNow': 'Clôturer la promotion',
    'cohort.confirmTransition': 'Confirmer la transition',
    'cohort.transitionCopy': 'Faire passer {code} à',
    'cohort.cancelWarning': 'L’annulation est définitive. La promotion ne peut pas être rouverte.',
    'cohort.confirmMove': 'Confirmer',
    'cohort.assignInstructor': 'Assigner un formateur',
    'cohort.currentInstructor': 'Actuellement : {name}',
    'cohort.assign': 'Assigner',
    'cohort.linkCrmAccount': 'Rattacher une entreprise',
    'cohort.crmAccountId': 'ID du compte entreprise',
    'cohort.crmAccountPick': 'Entreprise ou universite',
    'cohort.selectCompany': 'Choisir une entreprise ou universite...',
    'cohort.noCompaniesYet': 'Aucune entreprise — creez-en une',
    'cohort.crmAccountPickHint': 'Choisir un compte remplit l’identifiant ci-dessous et propose le rôle ; vous pouvez modifier l’un comme l’autre.',
    'cohort.crmRole': 'Rôle',
    'cohort.link': 'Rattacher',
    'cohort.crmAccount': 'Entreprise',
    'cohort.tabOverview': 'Vue d’ensemble',
    'cohort.tabEnrollments': 'Inscriptions',
    'cohort.tabContent': 'Contenu',
    'cohort.tabEngagement': 'Engagement',

    'cohortFormat.corporateBootcamp': 'Bootcamp entreprise',
    'cohortFormat.openEnrollment': 'Inscription libre',
    'cohortFormat.universityDiploma': 'Diplôme universitaire',
    'cohortFormat.selfPacedLms': 'LMS en autonomie',
    'cohortFormat.certificationPrep': 'Préparation à la certification',
    'cohortFormat.executiveMasterclass': 'Masterclass dirigeants',
    'cohortFormat.recruitmentLinked': 'Liée au recrutement',
    'cohortSourcing.academySourced': 'Recrutée par l’Académie',
    'cohortSourcing.selfSourced': 'Recrutée par le client',
    'crmRole.corporateClient': 'Client entreprise',
    'crmRole.universityPartner': 'Partenaire universitaire',

    // ─── Inscrire ────────────────────────────────────────────────────────────
    'enroll.title': 'Inscrire dans {code}',
    'enroll.learner': 'Apprenant',
    'enroll.submit': 'Inscrire',
    'enroll.offerAnotherCohort': 'Trouver une autre promotion avec des places libres',
    'enroll.goToExisting': 'Ouvrir le registre de cette promotion',
    'enroll.learnersArriveFromTheCrm': 'Les apprenants arrivent d’une affaire convertie, ou d’une entreprise ajoutant un employé à son propre effectif. Il n’y a aucun moyen d’en créer un depuis cet écran.',
    'enroll.batch': 'Inscription groupée',
    'enroll.batchTitle': 'Inscription groupée',
    'enroll.addLearner': 'Ajouter un apprenant',
    'enroll.batchSubmit': 'Inscrire {count} apprenants',
    'enroll.emptyRegister': 'Personne n’est encore inscrit',
    'enroll.emptyRegisterHint': 'Inscrivez un apprenant, ou acceptez une candidature qui désigne cette promotion.',
    'enroll.enrolledAt': 'Inscrit le',
    'enroll.detail': 'Compétence',
    'enroll.openDetail': 'Ouvrir',
    'enrollmentsQueue.lead': 'Tous les modules terminés, l’inscription encore active — ouvrez un apprenant pour le clôturer, ou la cohorte pour clôturer toute la classe.',
    'enrollmentsQueue.empty': 'Personne n’attend de clôture',
    'enrollmentsQueue.emptyHint': 'Un apprenant apparaît ici dès que son dernier module est terminé.',
    'enrollmentsQueue.totalWaiting': 'En attente de clôture',
    'enrollmentsQueue.totalWaitingHint': 'Tous les modules terminés, pas encore clôturé',
    'enrollmentsQueue.dualCreditWaiting': 'Crédit universitaire en attente',
    'enrollmentsQueue.dualCreditWaitingHint': 'Un diplôme universitaire en dépend',
    'enrollmentsQueue.oldestWaiting': 'Attente la plus longue',
    'enrollmentsQueue.oldestWaitingHint': 'Inscrit {when}',
    'enrollmentsQueue.noneWaiting': 'Personne en attente',
    'enroll.moveTo': 'Passer à :',
    'enroll.confirmTransition': 'Confirmer la transition',
    'enroll.transitionCopy': 'Faire passer {name} à',
    'enroll.occurredAt': 'Survenu le',
    'enroll.occurredAtHint': 'Quand cela s’est PRODUIT — pas quand cela a été saisi.',
    'enroll.reevaluate': 'Réévaluer',
    'enroll.reevaluateHint': 'Forcer une nouvelle évaluation des compétences après des changements hors circuit.',

    // ─── Vocabulaire des lots ────────────────────────────────────────────────
    'batch.mode': 'Mode groupé',
    'batch.chooseMode': 'Choisissez le comportement en cas d’échec…',
    'batch.modeHint': 'Au mieux par défaut : inscrire tous ceux qui peuvent l’être et nommer ceux qui ne l’ont pas été. Atomique annule tout le lot au premier refus.',
    'batch.atomic': 'Atomique — tout ou rien',
    'batch.atomicHint': 'Un seul refus annule tout le lot. Rien n’a été écrit.',
    'batch.bestEffort': 'Au mieux — résultat par élément',
    'batch.bestEffortHint': 'Chaque élément réussit ou échoue indépendamment ; consultez les résultats par élément ci-dessous.',

    // ─── Saisie des achèvements ──────────────────────────────────────────────
    'completion.title': 'Consigner un achèvement',
    'completion.module': 'Module',
    'completion.pct': '% d’achèvement',
    'completion.pctHint': '0–100 ici ; il n’y a pas de champ note — une réussite vient de la confirmation d’une évaluation.',
    'completion.state': 'État',
    'completion.source': 'Source',
    'completion.note': 'Remarque',
    'completion.submit': 'Consigner',
    'completionBatch.title': 'Import groupé d’achèvements',
    'completionBatch.hint': 'Collez des lignes CSV au format d’export LMS. La ligne d’en-tête est facultative ; les lignes sont validées avant tout envoi.',
    'completionBatch.invalidLine': 'Ligne',
    'completionBatch.skippedRows': '{count} lignes seront ignorées :',
    'completionBatch.parsed': '{count} lignes analysées et prêtes.',
    'completionBatch.submit': 'Importer {count} lignes',

    // ─── Dispense ────────────────────────────────────────────────────────────
    'waive.title': 'Dispenser du module',
    'waive.signerNote': 'Une dispense remplace une réussite par AUTORITÉ, pas par la note. Vous êtes le signataire — l’enregistrement porte votre identité issue du jeton.',
    'waive.reason': 'Motif',
    'waive.reasonHint': 'Obligatoire. Acquis antérieurs reconnus, crédits transférés — le motif est l’enregistrement.',
    'waive.nothingToWaive': 'Tous les modules sont déjà validés ou dispensés.',
    'waive.submit': 'Dispenser',

    // ─── Type de candidature (formulaire public) ─────────────────────────────
    'registration.kind.learner': 'Apprenant',
    'registration.kind.instructor': 'Formateur',

    // ─── Formulaire public ───────────────────────────────────────────────────
    'register.title': 'Candidater à l’Académie',
    'register.subtitle': 'Présentez-vous et notre équipe vous contactera. Candidater ne crée aucun compte — rien n’est mis en place pour vous tant que nous ne nous sommes pas parlé.',
    'register.emailHint': 'Nous répondons à cette adresse, et la connexion y sera rattachée plus tard — utilisez-en une que vous contrôlez.',
    'register.kind': 'Je candidate en tant que',
    'register.message': 'Quelque chose à nous signaler ? (facultatif)',
    'register.messageHint': 'Ce que vous voulez apprendre ou enseigner, votre parcours, vos délais.',
    'register.submit': 'Envoyer la candidature',
    'register.receivedTitle': 'Candidature reçue',
    'register.receivedCopy': 'Notre équipe la lira et répondra à l’adresse indiquée. Il n’y a pas de page de suivi, et rien n’a encore été créé à votre nom.',

    // ─── Sélecteurs ──────────────────────────────────────────────────────────
    'picker.person': 'Rechercher des personnes…',
    'picker.noPeople': 'Aucune personne correspondante',

    // ─── Notation ────────────────────────────────────────────────────────────
    'grading.allKinds': 'Tous',
    'grading.emptyQueue': 'Rien en attente de notation',
    'grading.emptyQueueHint': 'L’état stable normal d’une promotion bien menée — les nouveaux rendus apparaissent ici.',
    'grading.openDetail': 'Ouvrir',
    'grading.quizzesTab': 'Quiz',
    'grading.quizzesEmpty': 'Aucun quiz en attente',
    'grading.quizzesEmptyHint': 'Les réponses rédigées apparaissent ici dès qu’un apprenant les envoie.',
    'grading.aiCouldNotMark': 'L’IA n’a pas pu corriger',
    'grading.markedByInstructorBadge': 'Formateur',
    'grading.quizMarkingTitle': 'Corriger les réponses du quiz',
    'grading.markMode': 'Correction',
    'grading.overrideMode': 'Modification',
    'grading.overrideBanner': 'Modifier une note enregistrée est consigné dans l’audit.',
    'grading.choiceScoreLine': 'Questions à choix : {earned} sur {possible} points',
    'grading.markingGuide': 'Guide de correction',
    'grading.emptyAnswer': '(aucune réponse donnée)',
    'grading.aiSuggestion': 'L’IA suggère {points} points',
    'grading.useSuggestion': 'Utiliser la suggestion',
    'grading.pointsLabel': 'Points (max {max})',
    'grading.feedbackLabel': 'Commentaire',
    'grading.saveMarks': 'Enregistrer les notes',
    'grading.aiDraftingInfo': 'L’IA prépare une note — vous pouvez aussi noter dès maintenant.',
    'grading.scoreShort': 'Note',
    'grading.detailTitle': 'Évaluation',
    'grading.submission': 'Rendu',
    'grading.resubmit': 'Rendre à nouveau',
    'grading.resubmitNote': 'Enregistrer un nouveau rendu lève le blocage de renvoi et remet ceci dans la file du formateur.',
    'grading.checks': 'Contrôles de la grille',
    'grading.noChecks': 'Aucun constat de contrôle. Avec un vocabulaire vide, les formateurs notent sans assistance — c’est un système qui fonctionne.',
    'grading.finalScore': 'Note finale',
    'grading.confirm': 'Confirmer la note',
    'grading.confirmerNote': 'Vous êtes le confirmateur — l’enregistrement porte votre identité issue du jeton.',
    'grading.notConfirmable': 'Cette évaluation n’est plus confirmable — quelqu’un d’autre a peut-être agi avant vous.',
    'grading.refreshQueue': 'Actualiser la file',
    'grading.confirmedScore': 'Confirmée : {score}',
    'grading.returnTitle': 'Renvoyer à l’apprenant',
    'grading.returnReason': 'Motif',
    'grading.returnReasonHint': 'Obligatoire — le motif EST le contenu de l’état renvoyé ; sans lui, l’apprenant voit « Renvoyé » et rien d’autre.',
    'grading.returnConfirm': 'Renvoyer',
    'grading.returnedTitle': 'Renvoyée à l’apprenant',
    'grading.returnedBy': 'Par',
    'grading.aiDraft': 'Brouillon IA',
    'grading.aiDraftHint': 'Rédige une note provisoire et des constats de contrôle. Jamais une note définitive.',
    'grading.aiDraftLabel': 'Brouillon IA — jamais une note définitive',
    'grading.aiDraftScore': 'Brouillon IA : {score}',
    'grading.batchSelected': '{count} évaluations sélectionnées avec des notes',
    'grading.batchConfirm': 'Confirmer {count}',
    'grading.openTitle': 'Ouvrir une évaluation',
    'grading.kind': 'Type',
    'grading.enrollmentModuleId': 'ID du module d’inscription',
    'grading.enrollmentId': 'ID de l’inscription',
    'grading.capstoneSpecId': 'ID de la spécification du projet final',
    'grading.capstoneSpecHint': 'Obligatoire — de quel niveau relève ce projet final. Un projet final non rattaché ne peut pas certifier.',
    'grading.artifact': 'Pièce jointe',
    'grading.artifactHint': 'Envoyée directement depuis le navigateur vers le stockage après l’ouverture de l’évaluation ; l’API ne fait que signer et enregistrer.',
    'grading.openSubmit': 'Ouvrir',
    'grading.openArtifact': 'Ouvrir la pièce jointe',
    'grading.handedInAt': "Remis par l'apprenant le {when}",
    'grading.handedInUnrecorded': "Aucune remise enregistrée — ouvert par le personnel.",
    'grading.artifactUploadFailed': 'L’envoi de la pièce jointe a échoué — l’évaluation a été ouverte sans elle.',
    'grading.openedButArtifactFailed': 'L’évaluation a été ouverte, mais :',

    'assessmentKind.moduleRubric': 'Grille de module',
    'assessmentKind.capstone': 'Projet final',
    'verdict.pass': 'Réussi',
    'verdict.gap': 'Écart',
    'verdict.fail': 'Échec',
    'verdict.notApplicable': 'S.O.',

    // ─── Certifications (délivrance / cycle de vie) ──────────────────────────
    'credential.homeSubtitle': 'Délivrez, recherchez et vérifiez ce que l’Académie a décerné.',
    'credential.byHolder': 'Rechercher un titulaire',
    'credential.pickHolder': 'Choisir une personne',
    'credential.pickHolderHint': 'Les certifications sont détenues par des personnes : commencez par le titulaire, dont l’historique complet apparaît ici, révocations et expirations incluses.',
    'credential.publicVerifier': 'Ouvrir le vérificateur public',
    'credential.detailTitle': 'Certification',
    'credential.publicVerify': 'Vérification publique',
    'credential.holder': 'Titulaire',
    'credential.holderSnapshot': 'Titulaire (à la délivrance)',
    'credential.holderSnapshotNote': 'Le nom du titulaire est figé à la délivrance — le certificat dit ce qu’il disait à l’impression, même si le nom de la personne a changé depuis.',
    'credential.program': 'Programme',
    'credential.renews': 'Renouvelle',
    'credential.previousCredential': 'Certification précédente',
    'credential.noCompetencies': 'Aucune compétence consignée sur cette certification.',
    'credential.issueTitle': 'Délivrer une certification',
    'credential.issueModuleTitle': 'Certificat de module',
    'credential.issueConfirm': 'Délivrer',
    'credential.permanentNote': 'La délivrance est un acte public définitif : la certification devient vérifiable anonymement dès l’instant où elle existe.',
    'credential.programUnconfigured': 'Ce programme n’a aucun seuil défini',
    'credential.programUnconfiguredCta': 'Ouvrir le programme pour définir ses modules obligatoires',
    'credential.renewTitle': 'Renouveler',
    'credential.renewNote': 'Le renouvellement crée une NOUVELLE certification ; celle-ci demeure comme son historique.',
    'credential.renewConfirm': 'Renouveler',
    'credential.revokeTitle': 'Révoquer',
    'credential.revokeWarning': 'Révoquer {publicNo} est une déclaration publique définitive — le vérificateur anonyme le signalera, il ne le masquera pas.',
    'credential.revokeReason': 'Motif',
    'credential.revokeConfirm': 'Révoquer',

    // ─── Éditeur des modules du programme ────────────────────────────────────
    'track.moduleId': 'ID du module',
    'track.module': 'Module',
    'track.saveWholeSet': 'Enregistrer les {count} exigences',

    // ─── Référentiel ────────────────────────────────────────────────
    'framework.effectiveFrom': 'En vigueur à partir du',
    'framework.roleTitle': 'Intitulé',

    // ─── Aptitude ────────────────────────────────────────────────────────────

    // ─── Cursus ─────────────────────────────────────────────────────
    'curriculum.versionLabel': 'Version',
    'curriculum.current': 'Actuelle',
    'curriculum.frozen': 'Figée',
    'curriculum.frozenBadge': 'Figée',
    'curriculum.levels': 'Niveaux',
    'curriculum.modules': 'Modules',
    'curriculum.retiredOn': 'Retirée le',
    'curriculum.retired': 'Retirée le {date}',
    'curriculum.createVersion': 'Nouvelle version',
    'curriculum.emptyList': 'Aucune version de cursus',
    'curriculum.emptyListHint': 'Créez la version que les promotions épingleront.',
    'curriculum.frozenExplanation': 'Une promotion a épinglé cette version, figeant sa structure : niveaux, modules, crédits et notes de passage sont refusés (curriculum_frozen) parce qu’ils sont rétroactifs. Les leçons, les supports et les énoncés restent modifiables — le contenu n’apparaît dans aucun dénominateur. Les changements de structure relèvent d’une nouvelle version.',
    'curriculum.createNewVersionCta': 'Créer plutôt une nouvelle version',
    'curriculum.publish': 'Publier',
    'curriculum.retire': 'Retirer',
    'curriculum.createLevel': 'Nouveau niveau',
    'curriculum.levelCreated': 'Niveau créé.',
    'curriculum.levelIdHint': 'Le nouveau niveau apparaît dans la structure ci-dessous — ajoutez-y des modules.',
    'curriculum.levelId': 'ID du niveau',
    'curriculum.levelIdPasteHint': 'Depuis le reçu de création du niveau.',
    'curriculum.level': 'Niveau',
    'curriculum.createModule': 'Nouveau module',
    'curriculum.codePermanent': 'Définitif dès la création — des exigences y font référence et il ne peut jamais être renommé.',
    'curriculum.ordinal': 'Rang',
    'curriculum.overview': 'Vue d’ensemble',
    'curriculum.flagship': 'Emblématique',
    'curriculum.treeTitle': 'Structure',
    'curriculum.noLevels': 'Aucun niveau pour l’instant',
    'curriculum.noLevelsHint': 'Une version ne se publie qu’une fois qu’elle a des niveaux — créez le premier.',
    'curriculum.levelOrdinal': 'Niveau {ordinal}',
    'curriculum.levelNoModules': 'Aucun module dans ce niveau pour l’instant.',
    'curriculum.creditsShort': '{credits} cr',
    'curriculum.capstone': 'Projet final',
    'curriculum.dimensionsTitle': 'Dimensions',
    'curriculum.differentiator': 'Différenciateur',
    'curriculum.dimensionNoModules': 'Aucun module derrière cette dimension — un vrai manque, pas un problème d’affichage.',
    'curriculum.dimensionModuleCount': '{count} module(s)',
    'curriculum.dimensionNotTaught': 'Non enseignée dans {curriculum}.',
    'curriculum.dimensionsNoneTaught': 'Aucun module de {curriculum} n’est encore rattaché à une dimension.',
    'curriculum.dimensionsShowUntaught': 'Afficher les {count} dimension(s) que {curriculum} n’enseigne pas',
    'curriculum.dimensionsHideUntaught': 'Masquer les {count} dimension(s) que {curriculum} n’enseigne pas',
    'curriculum.codeNotEditable': 'Le code {code} n’est volontairement pas modifiable — le contenu des programmes et chaque message d’exigence non remplie y font référence.',
    'curriculum.retroactiveHint': 'Rétroactif — refusé dès que la version est figée.',
    'curriculum.isAssessed': 'Évalué',
    'curriculum.passScore': 'Note de passage',
    'curriculum.assessmentMarking': 'Première correction de l’évaluation',
    'curriculum.assessmentMarkingAiHint': 'L’IA propose une note et des vérifications ; un instructeur confirme toujours.',
    'curriculum.assessmentMarkingNoCodesHint': 'Les brouillons IA ont besoin de codes de vérification. Créez-les dans',
    'curriculum.checkCodesLinkLabel': 'Codes de vérification',
    'curriculum.assessmentMarkingNoCodesAskAdmin': 'Les brouillons IA ont besoin de codes de vérification — demandez à un administrateur de les créer.',
    'curriculum.assessed': 'Évalué · réussite ≥ {score}',
    'curriculum.notAssessed': 'Non évalué — alimente la progression seulement, jamais la maîtrise',
    'curriculum.dimensions': 'Dimensions',
    'curriculum.tools': 'Compétences et outils',
    'curriculum.noCodes': 'Aucun code pour l’instant.',

    // ─── CURSUS : les programmes d’études eux-mêmes ──────────────────────────
    'curriculum.curriculum': 'Cursus',
    'curriculum.curricula': 'Cursus',
    'curriculum.curriculaHint': 'Les programmes d’études que l’académie enseigne.',
    'curriculum.allCurricula': 'Tous les cursus',
    'curriculum.createCurriculum': 'Nouveau cursus',
    'curriculum.curriculumCode': 'Code',
    'curriculum.curriculumCodeHint': 'Court, en majuscules, et définitif dès la création — les rapports et les exigences le désignent.',
    'curriculum.curriculumName': 'Nom',
    'curriculum.curriculumSummary': 'Résumé',
    'curriculum.curriculumSummaryHint': 'Une ou deux phrases pour la page publique.',
    'curriculum.createCurriculumNext': 'Un cursus n’enseigne rien tant qu’il n’a pas une version avec des niveaux et des modules. Créez-en une ensuite — et si cette matière part d’une matière existante, copiez-en la structure.',
    'curriculum.versionCount': '{count} version(s)',
    'curriculum.noCurricula': 'Aucun cursus',
    'curriculum.noCurriculaHint': 'Créez le programme d’études auquel se rattachent les versions et les promotions.',
    'curriculum.deleteCurriculum': 'Supprimer le cursus',
    'curriculum.deleteCurriculumConfirm': 'Supprimer {name} ? Seul un cursus sans version peut être retiré — rien n’a été enseigné dessous.',
    'curriculum.editCurriculum': 'Modifier le cursus',
    'curriculum.curriculumCodeLocked': 'Défini une fois et jamais modifié — les rapports et les exigences le désignent. Un cursus au mauvais code se supprime tant qu’il ne porte aucune version, puis se recrée.',
    'curriculum.curriculumOrdinal': 'Ordre d’affichage',
    'curriculum.curriculumOrdinalHint': 'Le plus petit passe en premier, ici comme sur la page publique — la date de création ne devrait pas trancher par hasard.',
    'curriculum.versions': 'Versions',
    'curriculum.statCurricula': 'Cursus',
    'curriculum.statTotalVersions': 'Versions',
    'curriculum.statLive': 'En vigueur',
    'curriculum.statMultiLive': 'En double',
    'curriculum.versionsOfAll': 'Toutes les éditions de tous les cursus. Choisissez un cursus ci-dessus pour restreindre à une seule matière.',
    'curriculum.versionsOfScoped': 'Les éditions de {curriculum}. Les promotions en épinglent une et sont évaluées exactement dessus.',
    'curriculum.editVersion': 'Modifier la version',
    'curriculum.editVersionHint': 'Le libellé et la date de prise d’effet de cette édition.',
    'curriculum.dimensionsUnscoped': 'Nombre de modules sur tous les cursus et toutes les éditions — ce que l’académie a jamais placé derrière chaque axe. Choisissez un cursus ci-dessus pour ne compter que les siens.',
    'curriculum.dimensionsScoped': 'Nombre de modules pour {curriculum}, toutes éditions confondues. Un zéro ici signifie que cette matière n’enseigne rien sous cet axe, pas que personne ne le fait.',
    'curriculum.pickCurriculum': 'Choisir un cursus',
    'curriculum.versionCurriculumHint': 'Le programme d’études dont ceci est une édition. Les promotions des autres cursus ne sont pas affectées.',

    // ─── UNE SECONDE VERSION DE CURSUS ───────────────────────────────────────
    'curriculum.live': 'En vigueur',
    'curriculum.rendered': 'Sur la page publique',
    'curriculum.multiLiveTitle': '{curriculum} : {count} versions sont en vigueur en même temps',
    'curriculum.multiLiveBody': 'Toutes sont effectives aujourd’hui et aucune n’est retirée, mais la page publique n’en affiche qu’une — {label}. Les autres sont en vigueur et invisibles. C’est presque toujours un accident : retirez celles qui ne sont pas l’académie, ou déplacez leurs dates d’effet.',
    'curriculum.costsTitle': 'Ce que créer une version fait — et ne fait pas',
    'curriculum.costCohorts': 'Les promotions existantes restent sur leur version actuelle et y sont évaluées. Rien ne bouge sous elles.',
    'curriculum.costRequirements': 'Le contenu des programmes — et avec lui la notation de leurs modules — ne suit PAS. Il désigne des identifiants de modules, et la nouvelle version en a de nouveaux — tant qu’il n’est pas repris, une promotion sur cette version peut tout réussir sans qu’aucun titre ne soit délivré.',
    'curriculum.costPublic': 'La page publique ignore la nouvelle version jusqu’à sa date d’effet, et deux versions ne peuvent pas partager la même.',
    'curriculum.copyFrom': 'Copier la structure et les programmes depuis',
    'curriculum.copyFromNone': 'Partir de zéro (structure saisie à la main)',
    'curriculum.copyFromHint': 'Copie les niveaux, les modules et leurs étiquettes, et remappe le contenu des programmes (avec la notation de leurs modules) sur les nouveaux modules par code.',
    'curriculum.copyPreview': 'Prévisualiser la copie',
    'curriculum.copyPreviewTitle': 'Ce qui serait repris',
    'curriculum.copyAppliedTitle': 'Repris',
    'curriculum.copyCounts': '{levels} niveau(x), {modules} module(s), {programModules} module(s) de programme.',
    'curriculum.copyUnresolved': 'Non repris',
    'curriculum.copyClean': 'Tout est résolu — rien n’a été laissé de côté.',
    'curriculum.copyFailed': 'La version a été créée ; la copie de sa structure a échoué. Recopiez depuis l’écran de la version.',
    'curriculum.deleteVersion': 'Supprimer',
    'curriculum.deleteVersionConfirm': 'Supprimer la version {label} ? Cela retire purement et simplement ses niveaux et ses modules. C’est refusé si une promotion ou un programme en dépend — pour une version avec un historique réel, retirez-la plutôt.',
    'curriculum.deleteVersionDone': 'Version supprimée.',

    // ─── Programmes ──────────────────────────────────────────────────────────
    'nav.programs': 'Programmes',
    'program.name': 'Nom',
    'program.roleSku': 'SKU du rôle',
    // Le texte — PLATFORM-PLAN-5 §5b.2.
    'program.about': 'À propos du programme',
    // À qui il est vendu — PLATFORM-PLAN-5 §5b.1. `noneChosen` dit ce que le
    // vide SIGNIFIE, car il est l’inverse du vide dans le champ des marchés
    // juste à côté.
    'program.audience': 'Vendu à',
    'program.audienceHint': 'Lesquelles des trois portes publiques listent ce programme. Il reste au catalogue dans tous les cas.',
    'program.audience.businesses': 'Entreprises',
    'program.audience.individuals': 'Particuliers',
    'program.audience.universities': 'Universités',
    'program.audience.noneChosen': 'Personne ne l’a encore dit — ce programme n’est listé sous aucune des trois portes, et reste au catalogue.',
    'program.overview': 'Présentation',
    'program.overviewHint': 'Le paragraphe qu’un acheteur lit en premier. Jusqu’à {max} caractères — au-delà, c’est refusé, pas tronqué.',
    'program.overviewMissing': 'Aucune présentation rédigée pour l’instant.',
    'program.outcomes': 'Acquis',
    'program.outcomesHint': 'Ce qu’un apprenant saura faire ensuite, dans l’ordre de lecture. Jusqu’à {max}, chacun jusqu’à {each} caractères.',
    'program.outcomesCount': '{count} sur {max}',
    'program.outcomesEmpty': 'Aucun acquis rédigé pour l’instant.',
    'program.outcomeAdd': 'Ajouter un acquis',
    'program.outcomePlaceholder': 'Ce qu’un apprenant saura faire…',
    'program.outcomeOrdinal': 'l’acquis {n}',
    'program.durationWeeks': 'Durée (semaines)',
    'program.durationWeeksHint': 'La durée nominale d’une cohorte qui enseigne ce programme. Laissez vide si elle n’est pas fixée.',
    'program.weeks': '{n} semaines',
    'program.notWritten': 'Pas encore rédigé. La page publique présente ce programme par son nom et ses modules seuls tant qu’une présentation, des acquis ou une durée ne sont pas saisis ici.',
    'program.standards': 'Normes',
    'program.statTotal': 'Programmes',
    'program.statFlagship': 'Phares',
    'program.statUnbundled': 'Sans modules',
    'program.create': 'Nouveau programme',
    'program.codePermanent': 'Le code est la référence utilisée par les autres enregistrements — non modifiable par la suite.',
    'program.emptyList': 'Aucun programme',
    'program.emptyListHint': 'Un programme est ce qu’une promotion enseigne — des modules dans l’ordre, adossés à des normes.',
    'program.modulesNote': 'L’agencement s’enregistre EN BLOC — les rangs et les indicateurs « facultatif » forment un seul agencement, pas des modifications ligne à ligne.',
    'program.optional': 'Facultatif',
    'program.requiresCapstone': 'Projet de synthèse requis',
    'program.minScore': 'Note minimale',
    'program.minScorePlaceholder': 'ex. 70',
    'program.addModule': 'Ajouter un module',
    'program.noModules': 'Aucun module rattaché — les inscriptions aux promotions enseignant ce programme auront des listes de modules vides jusque-là.',

    // ─── Codes de contrôle ───────────────────────────────────────────────────
    'nav.checkCodes': 'Codes de contrôle',
    'checkCode.create': 'Nouveau code de contrôle',
    'checkCode.edit': 'Modifier {code}',
    'checkCode.empty': 'Aucun code de contrôle défini',
    'checkCode.emptyHint': 'L’état initial correct : les formateurs notent sans assistance et la rédaction IA reste désactivée. C’est un système qui fonctionne.',
    'checkCode.showRetired': 'Afficher les codes retirés',
    'checkCode.retired': 'Retiré',
    'checkCode.retire': 'Retirer',
    'checkCode.reactivate': 'Réactiver',
    'checkCode.neverDelete': 'Les codes ne sont jamais supprimés — un code figurant sur une évaluation passée doit rester résoluble à jamais.',
    'checkCode.everyKind': 'Tous les types',
    'checkCode.label': 'Libellé',
    'checkCode.description': 'Description',
    'checkCode.severity': 'Gravité',
    'checkCode.versionLabel': 'Libellé de version',
    'checkCode.versionLabelHint': 'Obligatoire — ce que signifiait un contrôle au moment où il a été relevé n’est pas récupérable depuis la ligne actuelle.',
    'checkCode.kinds': 'S’applique aux types',
    'checkCode.kindsHint': 'Aucune case cochée = s’applique à tous les types d’évaluation.',
    'checkCode.permanentNote': 'Les entrées sont DÉFINITIVES : le code ne peut jamais être renommé ni supprimé, seulement retiré.',
    'checkCode.codeImmutable': 'Le code lui-même ne peut pas changer — il est inscrit sur les lignes d’évaluation. Retirez-le et ajoutez-en un autre.',

    'severity.advisory': 'Indicative',
    'severity.minor': 'Mineure',
    'severity.major': 'Majeure',
    'severity.critical': 'Critique',

    // ─── Parcours formateur ──────────────────────────────────────────────────

    // ─── État du système ─────────────────────────────────────────────────────

    // ─── Mes dossiers (le portail apprenant) ─────────────────────────────────
    'my.title': 'Mes dossiers',
    'my.subtitle': 'Vos inscriptions et vos certifications, telles que l’Académie les détient.',
    'my.profile': 'Profil',
    'my.enrollments': 'Mes inscriptions',
    'my.noEnrollments': 'Aucune inscription pour l’instant',
    'my.noEnrollmentsHint': 'Lorsque vous serez inscrit dans une promotion, elle apparaîtra ici.',
    'my.enrolledOn': 'Inscrit le {date}',
    'my.continueLearning': 'Continuer la formation',
    'my.credentials': 'Mes certifications',
    'my.noCredentials': 'Aucune certification pour l’instant',
    'my.noCredentialsHint': 'Les certifications que vous obtenez apparaissent ici, chacune avec un lien de vérification publique.',
    'my.verifyLink': 'Page de vérification publique',
    'my.noRecord': 'Vous n’avez pas de dossier d’apprenant',
    'my.noRecordHint': 'Votre compte est rattaché à une autorité administrative, pas à un dossier d’apprenant : rien ne s’affiche ici.',
    'my.staffNoLearner': 'Pas encore de dossier de formation',
    'my.staffNoLearnerHint': 'Votre compte peut aussi suivre des formations. Cliquez ci-dessous pour commencer.',
    'my.becomeLearner': 'Commencer comme apprenant',

    // ───────────────────────── rédaction du contenu des modules (phase 8)

    'contentKind.text': 'Texte',
    'contentKind.link': 'Lien',
    'contentKind.video': 'Vidéo',
    'contentKind.document': 'Document',
    'contentKind.meeting': 'Réunion',

    'lessons.title': 'Leçons',
    'lessons.addLesson': 'Ajouter une leçon',
    'lessons.editLesson': 'Modifier la leçon',
    'lessons.summary': 'Résumé',
    'lessons.emptyTitle': 'Aucune leçon pour l’instant',
    'lessons.emptyHint': 'Ajoutez la première leçon — le plan de référence dont part chaque promotion. Les leçons restent modifiables même sur une version figée.',
    'lessons.noContent': 'Aucun support sur cette leçon pour l’instant.',
    'lessons.deleteRefused': 'Cette leçon ne peut pas être supprimée — des apprenants l’ont déjà cochée ou annotée. Modifiez la leçon à la place.',
    'lessons.addContent': 'Ajouter un support',
    'lessons.editContent': 'Modifier le support',
    'lessons.kind': 'Type',
    'lessons.body': 'Corps',
    'lessons.url': 'URL',
    'lessons.urlMustBeAbsolute': 'Doit être une URL http(s) absolue.',
    'lessons.uploadFile': 'Envoyer un fichier',
    'lessons.uploadHint': 'Ou envoyez le fichier lui-même au lieu d’y faire un lien.',
    'lessons.videoUploadOnly': "Les vidéos doivent être envoyées. Un lien vers une vidéo externe n’est pas autorisé : toute personne ayant le lien pourrait la regarder ou la télécharger.",
    'lessons.uploadUnavailable': 'Le stockage de fichiers n’est pas configuré sur ce déploiement — faites plutôt un lien vers le fichier par URL.',
    'lessons.uploading': 'Envoi… {pct} %',
    'lessons.uploaded': 'Envoyé',

    'assignment.title': 'Devoir',
    'assignment.create': 'Rédiger l’énoncé',
    'assignment.delete': 'Supprimer l’énoncé',
    'assignment.brief': 'Énoncé',
    'assignment.files': 'Fichiers fournis avec cet énoncé',
    'assignment.attachFile': 'Joindre un fichier',
    'assignment.requirement': 'Ce que les apprenants rendent',
    'assignment.requirementPlaceholder': 'Choisissez ce qui est rendu…',
    'assignment.requirementUndecided': 'Il n’y a pas de valeur par défaut — choisissez délibérément. Ceci détermine ce que l’écran de notation attend.',
    'assignment.emptyTitle': 'Aucun énoncé de devoir',
    'assignment.emptyHint': 'Sans énoncé, les apprenants écrivent dans une zone de rendu à laquelle aucune consigne n’est attachée.',
    'assignment.passMarkLivesOnModule': 'La note de passage se trouve sur le module ci-dessus (figée avec la version) — elle n’est volontairement pas répétée ici.',

    'submissionRequirement.text': 'Un texte rédigé',
    'submissionRequirement.link': 'Un lien',
    'submissionRequirement.file': 'Un fichier envoyé',

    'cohortContent.modulePicker': 'Module',
    'cohortContent.moduleLayerHeading': 'Depuis le module (toutes les promotions le voient)',
    'cohortContent.readOnlyLabel': 'Lecture seule ici',
    'cohortContent.moduleLayerEmpty': 'Le module ne fournit encore aucun support.',
    'cohortContent.cohortLayerHeading': 'Les supports propres à cette promotion',
    'cohortContent.addItem': 'Ajouter un support',
    'cohortContent.emptyTitle': 'Rien d’ajouté pour cette session',
    'cohortContent.emptyHint': 'Enregistrements, diapositives, liens de réunion et exemples pour cette promotion vont ici, sans toucher aux autres.',
    'cohortContent.readOnlyNotYourCohort': 'Lecture seule : vous n’êtes pas le formateur assigné de cette promotion.',
    'cohortContent.readOnlyDelisted': 'Lecture seule : votre statut de formateur est radié. Une nouvelle certification rétablit la rédaction — se déconnecter n’y changera rien.',
    'cohortContent.readOnlyClosed': 'Lecture seule : cette promotion est terminée ou annulée, son contenu de diffusion est désormais un enregistrement.',

    // ───────────────────────────────────── rédaction des quiz (phase 9)

    'quizKind.singleChoice': 'Choix unique',
    'quizKind.multiChoice': 'Choix multiple',

    'quiz.title': 'Quiz',
    'quiz.create': 'Ajouter un quiz',
    'quiz.emptyTitle': 'Aucun quiz pour l’instant',
    'quiz.emptyHint': 'Un quiz est une auto-évaluation non notée — corrigée automatiquement, elle ne peut jamais aboutir à une note, un palier ou une certification.',
    'quiz.questionCount': '{count} questions',
    'quiz.attemptCount': '{count} tentatives',
    'quiz.editorTitle': 'Éditeur de quiz',
    'quiz.backToModule': 'Retour au module',
    'quiz.backToAssessment': 'Retour à l’évaluation',
    'quiz.backToLesson': 'Retour à la leçon',
    'quiz.locked': 'Ce quiz compte {count} tentatives enregistrées : sa structure — questions, options, points — est verrouillée. Un score enregistré dont les questions ont changé est un nombre que personne ne peut expliquer. Le titre, les consignes, le plafond de tentatives et le seuil indicatif restent modifiables.',
    'quiz.instructions': 'Consignes',
    'quiz.lesson': 'Leçon',
    'quiz.lessonHint': 'Où le quiz apparaît pour les apprenants.',
    'quiz.moduleLevelCheck': 'Contrôle au niveau du module (aucune leçon précise)',
    'quiz.maxAttempts': 'Limite de tentatives',
    'quiz.maxAttemptsHint': 'Vide = illimité.',
    'quiz.passPct': 'Seuil indicatif (%)',
    'quiz.passPctAdvisory': 'Indicatif uniquement — affiché à l’apprenant sous la forme « vous avez obtenu 60 %, le seuil est de 70 % ». Cela ne conditionne rien : les quiz ne comptent jamais dans les notes, les paliers ou la certification. La vraie note de passage se trouve sur le module.',
    'quiz.questions': 'Questions',
    'quiz.addQuestion': 'Ajouter une question',
    'quiz.newPrompt': 'Nouvelle question — modifiez l’intitulé',
    'quiz.noQuestionsTitle': 'Aucune question pour l’instant',
    'quiz.noQuestionsHint': 'Un quiz sans question ne peut pas être passé (quiz_unconfigured) — la rédaction est inachevée, rien n’est cassé.',
    'quiz.prompt': 'Intitulé',
    'quiz.kind': 'Type',
    'quiz.points': 'Points',
    'quiz.options': 'Options',
    'quiz.oneCorrect': 'exactement une bonne réponse',
    'quiz.manyCorrect': 'une ou plusieurs bonnes réponses',
    'quiz.markCorrect': 'Marquer l’option {n} comme correcte',
    'quiz.optionText': 'Texte de l’option {n}',
    'quiz.removeOption': 'Supprimer l’option {n}',
    'quiz.optionOrdinal': 'l’option {n}',
    'quiz.addOption': 'Ajouter une option',
    'quiz.needTwoOptions': 'Une question a besoin d’au moins deux options.',
    'quiz.needACorrectOption': 'Marquez au moins une option comme correcte.',
    'quiz.saveOptions': 'Enregistrer les options',
    'quiz.saveQuestion': 'Enregistrer la question',
    'quiz.deleteQuestion': 'Supprimer la question',
    'quiz.questionLocked': 'Verrouillée — {count} tentatives enregistrées.',
    'quiz.delete': 'Supprimer le quiz',
    'quiz.deleteHint': 'Supprimer un quiz supprime ses questions et ses options. Possible uniquement tant qu’aucune tentative n’existe.',
    'quiz.deleteLocked': 'Ce quiz compte {count} tentatives enregistrées et ne peut pas être supprimé — un score enregistré dont le quiz a disparu est un nombre que personne ne peut expliquer.',

    // ───────────────────── questions à réponse libre et correction (phase 2, plan IA)
    'quizKind.shortAnswer': 'Réponse courte',
    'quizKind.essay': 'Rédaction',
    'quiz.freeTextBadge': 'Texte libre',
    'quiz.gateBadge': 'Verrou',
    'quiz.markingModeHint': 'Seules les réponses libres sont corrigées ; les questions à choix sont toujours notées automatiquement.',
    'quiz.markingGuide': 'Guide de correction',
    'quiz.markingGuideHint': 'Ce que contient une réponse complète. Utilisé par le correcteur, jamais montré aux apprenants.',
    'quiz.markingGuideRequired': 'Une question à réponse libre a besoin d’un guide de correction avant d’être enregistrée.',
    'quiz.maxAnswerChars': 'Longueur maximale de la réponse',
    'quiz.maxAnswerCharsHint': 'Entre 50 et 10 000 caractères.',

    // ───────────────────────── Rédaction assistée par IA (phase 5) — le
    // brouillon n’est jamais enregistré par ces écrans ; c’est le bouton
    // Enregistrer existant du curateur qui persiste quoi que ce soit.
    'aiDraft.generate': '✦ Générer avec l’IA',
    'aiDraft.optionsTitle': 'Générer un quiz avec l’IA',
    'aiDraft.reviewTitle': 'Relire le brouillon',
    'aiDraft.questionCount': 'Nombre de questions',
    'aiDraft.kinds': 'Types de questions',
    'aiDraft.difficulty': 'Difficulté',
    'aiDraft.difficulty.intro': 'Introduction',
    'aiDraft.difficulty.core': 'Standard',
    'aiDraft.difficulty.stretch': 'Approfondi',
    'aiDraft.notes': 'Notes pour l’IA (facultatif)',
    'aiDraft.notesHint': 'Des indications sur le sujet ou l’accent à mettre. Traitées comme des données, jamais comme une instruction qui outrepasse les règles d’ancrage au contenu.',
    'aiDraft.draftTitle': 'Titre',
    'aiDraft.truncatedBanner': 'Le contenu du cours est long — seule la première partie a servi à rédiger ce brouillon.',
    'aiDraft.droppedBanner': '{count} question(s) ne respectaient pas les règles du quiz et ont été écartées.',
    'aiDraft.removeQuestion': 'Supprimer la question {n}',
    'aiDraft.correct': 'Correct',
    'aiDraft.saveAsQuiz': 'Enregistrer comme quiz',
    // ─── Screening (for HR) — SKILL-ASSESSMENT-PLAN.md §4 ───────────────────
    'screening.title': 'Tests de présélection (pour les RH)',
    'screening.intro': 'Tests envoyés par les RH aux candidats et employés pour mesurer une compétence de ce module — invisibles aux apprenants, proposés aux RH une fois publiés.',
    'screening.newQuiz': 'Nouveau quiz de présélection',
    'screening.draftQuiz': 'Rédiger un quiz avec l’IA',
    'screening.newTask': 'Nouvelle tâche pratique',
    'screening.editTask': 'Modifier la tâche pratique',
    'screening.noSkills': 'Ajoutez d’abord les compétences et outils de ce module ci-dessus — chaque élément de présélection en mesure un.',
    'screening.empty': 'Aucun élément de présélection pour l’instant. Créez un quiz ou une tâche pratique pour l’une des compétences de ce module.',
    'screening.quizzes': 'Quiz',
    'screening.tasks': 'Tâches pratiques',
    'screening.quizFacts': '{count} questions · {minutes} min',
    'screening.taskFacts': '{requirement} · {minutes} min',
    'screening.published': 'Publié',
    'screening.draft': 'Brouillon',
    'screening.publish': 'Publier',
    'screening.unpublish': 'Dépublier',
    'screening.copy': 'Copier',
    'screening.copyHint': 'Créer une copie brouillon modifiable — pour changer un quiz qui a déjà des tentatives.',
    'screening.translate': 'Traduire avec l’IA',
    'screening.translateTitle': 'Traduire ce quiz',
    'screening.translateInto': 'Traduire en',
    'screening.translateHint': 'L’IA rédige la traduction avec les mêmes questions et réponses. Vous la relisez, puis elle est enregistrée comme nouveau quiz brouillon dans cette langue.',
    'screening.saveAsQuiz': 'Enregistrer comme quiz de présélection',
    'screening.skill': 'Compétence mesurée',
    'screening.skillHint': 'L’une des compétences et outils de ce module — le même code que les RH utilisent pour la compétence.',
    'screening.level': 'Niveau visé',
    'screening.levelHint': 'Les questions doivent distinguer une personne de ce niveau d’une personne du niveau inférieur.',
    'screening.levelName.1': '1 — Débutant',
    'screening.levelName.2': '2 — En progression',
    'screening.levelName.3': '3 — Opérationnel',
    'screening.levelName.4': '4 — Avancé',
    'screening.levelName.5': '5 — Expert',
    'screening.language': 'Langue',
    'screening.language.en': 'Anglais',
    'screening.language.ar': 'Arabe',
    'screening.language.fr': 'Français',
    'screening.minutes': 'Durée suggérée (minutes)',
    'screening.createAndAddQuestions': 'Créer et ajouter les questions',
    'screening.draftBrief': 'Rédiger l’énoncé avec l’IA',
    'screening.draftBriefHint': 'Remplit le titre, l’énoncé et le rendu. Rédigez vous-même le guide de correction.',
    'screening.brief': 'Ce qui est demandé au candidat',
    'screening.briefHint': 'Affiché au candidat. Précisez exactement ce qu’il doit produire et rendre.',
    'screening.markingGuide': 'Guide de correction',
    'screening.markingGuideHint': 'Ce que contient une réponse complète. Seuls les correcteurs le voient — jamais le candidat.',
    'screening.badge': 'Quiz de présélection (pour les RH)',
    'screening.editorHint': 'Hors cours. Une seule tentative, pas de note de passage — le score est transmis aux RH comme niveau de compétence.',
    'screening.lockedHint': 'Verrouillé : ce quiz a des tentatives. Copiez-le pour changer la compétence ou la langue.',
    'screening.skillHintStandalone': 'Optionnel. Un code de compétence pour les RH — non validé par rapport à un module.',
    'screening.skillPlaceholder': 'ex. Revit, Dynamo, AutoCAD',
    'aiDraft.regenerate': 'Régénérer',
    'aiDraft.partialQuizCreated': 'Un quiz partiel a été créé avant cet échec.',
    'aiDraft.viewPartialQuiz': 'Voir le quiz partiel',
    'aiDraft.briefModalTitle': 'Rédiger un énoncé de devoir avec l’IA',
    'aiDraft.useThisDraft': 'Utiliser ce brouillon',
    'aiDraft.suggestedChecks': 'Contrôles que cet énoncé mobilise : {codes}',
    'aiDraft.noSuggestedChecks': 'Aucun code de contrôle pour l’instant — le brouillon n’en suggérera aucun.',

    // L’écran module de l’apprenant (LearnModule). Deux chiffres de
    // progression, jamais mélangés.
    'learn.title': 'Module',
    'learn.position': '{position} sur {count}',
    'learn.credits': '{credits} crédits',
    'learn.assessed': 'Évalué',
    'learn.recordedProgress': 'Progression enregistrée',
    'learn.selfReportedProgress': 'Ma propre progression',
    'learn.selfReportedHint': 'Vos propres coches — affichées à côté du chiffre enregistré, jamais fusionnées avec lui.',
    'learn.noLessonsYet': 'Aucune leçon pour l’instant',
    'learn.bestScore': 'Meilleure note {score}',
    'learn.lessonTitle': 'Leçon',
    'learn.material': 'Supports',
    'learn.noMaterialHint': "Rien n'a encore été joint à cette leçon. Votre formateur ajoute enregistrements, lectures et liens au fil de la promotion.",
    'learn.readOnly': "Vous consultez l'inscription de cet apprenant, pas la vôtre. Les coches, notes, quiz et le bouton Suivant appartiennent à l'apprenant et ne sont donc pas disponibles ici.",
    'learn.lessonQuizzes': 'Quiz de cette leçon',
    'learn.moduleQuizzes': 'Après ce module',
    'learn.lessonNav': 'Leçons',
    'learn.backToModule': 'Retour au module',
    'learn.lessonMissingTitle': "Cette leçon ne fait pas partie de ce module",
    'learn.lessonMissingHint': "Elle a peut-être été retirée du programme depuis la création du lien.",
    'learn.yourSubmission': 'Votre rendu',
    'learn.yourAnswer': 'Votre réponse',
    'learn.answerPlaceholder': 'Écrivez votre réponse ici, joignez vos fichiers ci-dessous, ou les deux.',
    'learn.attachFile': 'Joindre un fichier',
    'learn.uploading': 'Envoi en cours… {pct} %',
    'learn.uploadFailed': "Le fichier n'a pas pu être envoyé au stockage. Si votre connexion fonctionne, demandez à un administrateur de vérifier les paramètres de stockage.",
    'learn.saveDraft': 'Enregistrer le brouillon',
    'learn.handItIn': 'Rendre',
    'learn.handInWarning': "Une fois rendu, vous ne pouvez plus le modifier — votre formateur doit d'abord vous le renvoyer.",
    'learn.handedIn': 'Rendu. Votre formateur l’a reçu.',
    'learn.handedInAt': 'Rendu le {when}. Votre formateur l’a reçu.',
    'learn.returnedBecause': 'Votre formateur vous l’a renvoyé : {reason}',
    'learn.uploadRefused': "Le fichier n'a pas pu être téléversé. Si cela se reproduit, prévenez votre formateur — les réglages de stockage sont peut-être en cause.",
    'submissionState.draft': 'Brouillon',
    'submissionState.awaitingInstructor': 'Chez votre formateur',
    'submissionState.confirmed': 'Évalué',
    'submissionState.returned': 'Renvoyé',
    'learn.lessons': 'Leçons',
    'learn.noLessonsTitle': 'Aucune leçon pour l’instant',
    'learn.noLessonsHint': 'Les supports de ce module sont en préparation — il ne manque rien de votre côté.',
    'learn.cohortExtras': 'De votre promotion',
    'learn.cohortLayer': 'Votre promotion',
    'learn.tick': 'Fait',
    'learn.status.done': 'Terminé',
    'learn.status.liveOn': 'En direct · {when}',
    'learn.status.held': 'Séance tenue',
    'learn.status.quizPending': 'Quiz à passer',
    'learn.status.quizPassed': 'Quiz réussi',
    'learn.materialCount': 'Contenus : {count}',
    'learn.openLesson': 'Ouvrir la leçon',
    'learn.materialList': 'Contenus de la leçon',
    'learn.opened': 'Ouvert',
    'learn.group.videos': 'Vidéos',
    'learn.group.documents': 'Documents',
    'learn.group.readings': 'Lectures',
    'learn.group.files': 'Fichiers de conception',
    'learn.group.links': 'Liens',
    'learn.pdfFallback': 'Si le document ne s’affiche pas ici, téléchargez-le.',
    'learn.steps': 'Étapes de la leçon',
    'learn.step.attend': 'Assister à la séance en direct',
    'learn.step.attendHint': 'Validé dès que votre formateur marque la séance comme tenue.',
    'learn.step.attendDone': 'La séance a eu lieu.',
    'learn.step.watch': 'Regarder le contenu',
    'learn.step.watchHint': 'Marqué terminé quand vous passez à la suite.',
    'learn.step.watchDone': 'Regardé.',
    'learn.step.complete': 'Parcourir le contenu',
    'learn.step.noQuiz': 'Cette leçon n’a pas de quiz.',
    'learn.step.next': 'Continuer',
    'learn.step.doneLabel': 'Terminé',
    'learn.markComplete': 'Marquer comme terminé',
    'learn.fileOpensElsewhere': 'S’ouvre dans le logiciel installé pour ce format, comme Revit ou AutoCAD.',
    'learn.download': 'Télécharger',
    'learn.noMaterial': 'Aucun support sur cette leçon pour l’instant.',
    'learn.openFile': 'Ouvrir le fichier',
    'learn.openLink': 'Ouvrir',
    'learn.noteToggle': 'Ma note',
    'learn.noteTitle': 'Ma note',
    'learn.notePlaceholder': 'Privée — ni les formateurs ni le personnel ne la voient.',
    'notes.aiSummaryButton': '✦ Résumer la leçon dans ma note',
    'notes.aiSummaryTitle': 'Points clés proposés — pas encore enregistrés',
    'notes.aiSummaryInsert': 'Insérer dans ma note',
    'notes.aiSummaryDiscard': 'Ignorer',
    'tutor.title': 'Poser une question sur cette leçon',
    'tutor.askPlaceholder': 'Posez une question sur cette leçon…',
    'tutor.send': 'Demander',
    'tutor.thinking': 'Réflexion en cours…',
    'tutor.remaining': 'Il vous reste {count} questions aujourd’hui',
    'tutor.ungrounded': 'Non couvert par cette leçon — demandez à votre formateur',
    'tutor.clearHistory': "Effacer l'historique",
    'tutor.clearConfirm': 'Effacer toutes les questions de cette leçon ?',
    'learn.quizzes': 'Auto-évaluations',
    'learn.noQuizzesTitle': 'Aucune auto-évaluation',
    'learn.noQuizzesHint': 'Ce module n’a pas de quiz — ce sont des exercices facultatifs, pas une obligation.',
    'learn.quizBest': 'Meilleur {score} %',
    'learn.attemptsOf': '{used} tentatives sur {max}',
    'learn.attemptsUnlimited': '{used} tentatives',
    'learn.takeQuiz': 'Passer',
    'learn.retakeQuiz': 'Repasser',
    'learn.quizAttemptsExhausted': 'Vous avez utilisé toutes vos tentatives. Revisionnez le contenu de la leçon et réessayez.',
    'learn.restartLesson': 'Recommencer la leçon',
    'learn.quizUnconfiguredTitle': 'Pas encore prêt à être passé',
    'learn.quizUnconfiguredHint': 'Cette auto-évaluation est encore en cours de rédaction — rien n’est anormal de votre côté.',
    'learn.quizAdvisoryMark': 'Le seuil est de {pct} % — indicatif seulement ; cela ne compte jamais dans votre note.',
    'learn.submitAttempt': 'Envoyer',
    'learn.attemptNumber': 'Tentative {n}',
    'learn.quizScoredAgainstMark': 'Vous avez obtenu {score} % — le seuil est de {pct} %.',
    'learn.questionCorrect': 'Correct',
    'learn.questionIncorrect': 'Incorrect',
    'learn.questionN': 'Question {n}',
    'learn.quizAwaitingMarking': 'En attente de correction',
    'learn.viewFeedback': 'Voir les commentaires',
    'learn.quizAwaitingAiMark': 'Envoyé — en cours de correction par l’IA. Cela prend généralement moins d’une minute.',
    'learn.quizAwaitingInstructorMark': 'Envoyé — votre formateur corrigera vos réponses rédigées.',
    'learn.canContinueToNextLesson': 'Vous pouvez continuer vers la leçon suivante.',
    'learn.charsRemaining': '{count} caractères restants',
    'learn.markedByAi': 'Corrigé par l’IA',
    'learn.markedByInstructor': 'Corrigé par votre formateur',
    'learn.pointsAwarded': '{points} sur {max} points',
    'learn.assignment': 'Devoir',
    'learn.noAssignmentTitle': 'Aucun devoir',
    'learn.noAssignmentHint': 'Ce module n’a pas encore d’énoncé de devoir.',
    'learn.handIn': 'À rendre : {what}',
    'learn.locked': 'Verrouillé',
    'learn.lockedByQuiz': 'Réussissez le contrôle de « {lesson} » pour ouvrir cette leçon.',
    'learn.lockedBySessionDated': 'S’ouvre après la session en direct de « {lesson} », {when}.',
    'learn.lockedBySessionUndated': 'S’ouvre après la session en direct de « {lesson} ». Aucune date n’a encore été fixée.',
    'learn.moduleLocked': 'Le module {code} doit être validé avant l’ouverture de celui-ci. Vous pouvez lire en avance, mais vos coches ne compteront pas encore.',
    'learn.liveLesson': 'Session en direct',
    'learn.liveLessonHint': 'Cette leçon est une séance en direct avec votre cohorte ; son contenu est ci-dessous.',
    'learn.sessionStarts': 'Commence {when}',
    'learn.sessionStarted': 'A commencé {when}',
    'learn.sessionDuration': '{minutes} minutes',
    'learn.sessionJoin': 'Rejoindre la session',
    'learn.sessionHeld': 'Cette session a eu lieu.',
    'learn.sessionNotScheduled': 'Votre formateur n’a pas encore fixé de date pour cette session.',
    'learn.sessionRecording': 'Enregistrement',
    'learn.liveNow': 'En direct',
    'learn.sessionEnter': 'Entrer dans la classe',
    'learn.sessionOpensAt': 'La classe ouvre à {when}.',
    'learn.sessionCancelled': 'Cette session a été annulée. Votre formateur en programmera une autre.',
    'learn.sessionRecorded': 'Cette session a été enregistrée.',
    'learn.watchRecording': "Regarder l’enregistrement",
    'learn.videoNotUploaded': "Cette vidéo n’a pas encore été envoyée sur l’Académie et ne peut donc pas être lue ici. Demandez à votre formateur.",
    'learn.mediaRetry': "Réessayer",
    'learn.play': "Lire",
    'learn.hidePlayer': "Masquer le lecteur",
    'learn.fullScreen': "Plein écran",
    'learn.exitFullScreen': "Quitter le plein écran",
    'learn.mediaUnavailable': "Cet enregistrement n'a pas pu être lu. Réessayez, ou signalez-le à votre formateur si cela se reproduit.",
    'learn.sessionEnded': 'Cette session est terminée.',
    'learn.liveConnecting': 'Connexion à la classe…',
    'learn.liveEmbedFailed': 'La classe n’a pas pu être chargée.',
    'learn.liveRetry': 'Réessayer',
    'learn.next.nextQuiz': 'Suivant : {title}',
    'learn.next.nextLesson': 'Leçon suivante : {title}',
    'learn.next.nextLessonGeneric': 'Leçon suivante',
    'learn.next.moduleAssessment': 'Suivant : évaluation du module',
    'learn.next.awaitingAssessmentMark': 'Évaluation en cours avec votre formateur',
    'learn.next.continueToNextModule': 'Continuer vers le module suivant',
    'learn.next.nextModule': 'Module suivant : {title}',
    'learn.next.programmeComplete': 'Programme terminé',
    'learn.next.goToMyLearning': 'Aller à Mon apprentissage',
    'learn.completedAutomatically': 'Terminé automatiquement',
    'cohort.tabSessions': 'Sessions',
    'cohortSessions.module': 'Module',
    'cohortSessions.schedule': 'Planifier une session',
    'cohortSessions.noneTitle': 'Aucune session planifiée',
    'cohortSessions.noneHint': 'Les leçons en direct de ce module ont besoin d’une date avant que les apprenants puissent y assister, et avant que les leçons suivantes ne s’ouvrent.',
    'cohortSessions.state.scheduled': 'Planifiée',
    'cohortSessions.state.held': 'Tenue',
    'cohortSessions.state.cancelled': 'Annulée',
    'cohortSessions.gatesNothing': 'N’ouvre rien',
    'cohortSessions.markHeld': 'Marquer comme tenue',
    'cohortSessions.markHeldHint': 'Ouvre toutes les leçons en attente de cette session, pour toute la cohorte.',
    'cohortSessions.reopen': 'Marquer comme non tenue',
    'cohortSessions.reschedule': 'Reprogrammer',
    'cohortSessions.rescheduleHint': 'La cohorte est informée du nouvel horaire et reçoit de nouveau son rappel.',
    'cohortSessions.saveNewTime': 'Enregistrer le nouvel horaire',
    'cohortSessions.lessonScheduledOn': '{lesson} — déjà programmée le {when}',
    'cohortSessions.lessonHeldOn': '{lesson} — déjà tenue le {when}',
    'cohortSessions.closeOut.question': 'Cette séance est-elle terminée ?',
    'cohortSessions.closeOut.hint': 'Sans réponse, les leçons suivantes restent verrouillées, et un enregistrement ne suffit pas : il s\'arrête aussi si la connexion coupe.',
    'cohortSessions.closeOut.done': 'Oui, elle est terminée',
    'cohortSessions.closeOut.continuing': 'J\'ai été déconnecté(e) — je continue',
    'cohortSessions.closeOut.redo': 'Elle doit être refaite',
    'cohortSessions.closeOut.continuingUntil': 'La salle reste ouverte jusqu\'à {when}. La question vous sera reposée ensuite.',
    'cohortSessions.closeOut.awaitingNewDate': 'À refaire. Reprogrammez-la, ou marquez-la comme tenue si elle s\'est terminée.',
    'cohortSessions.cancel': 'Annuler la session',
    'cohortSessions.opensLessons': 'Les leçons en attente de cette session sont désormais ouvertes pour la cohorte.',
    'cohortSessions.titleField': 'Titre',
    'cohortSessions.lesson': 'Leçon',
    'cohortSessions.noLesson': 'Aucune leçon — permanence ou séance de révision',
    'cohortSessions.noLiveLessons': 'Ce module n’a aucune leçon en direct, donc une session ici n’ouvre rien. C’est adapté à une permanence.',
    'cohortSessions.startsAt': 'Commence à',
    'cohortSessions.duration': 'Durée (minutes)',
    'cohortSessions.joinUrl': 'Lien de connexion',
    'cohortSessions.joinUrlHint': 'Collez le lien de votre outil de visioconférence. Il est montré à la cohorte et jamais ouvert par l’Academy.',
    'cohortSessions.delivery': 'Mode de réunion',
    'cohortSessions.deliveryPasted': 'Un lien externe',
    'cohortSessions.deliveryIntegrated': 'Dans l’Academy',
    'cohortSessions.deliveryIntegratedHint': 'Le cours se déroule dans la page de la leçon.',
    'cohortSessions.deliveryUnavailable': 'La visioconférence n’est pas configurée sur ce déploiement ; seul un lien externe est disponible.',
    'cohortSessions.joinBefore': 'Ouverture (minutes avant)',
    'cohortSessions.joinBeforeHint': 'À quel moment les apprenants peuvent entrer. Appliqué par le serveur, pas seulement à l’écran.',
    'cohortSessions.integratedBadge': 'Dans l’Academy',
    'cohortSessions.enter': 'Entrer comme hôte',
    'nextClass.title': 'Prochain cours',
    'nextClass.none': 'Aucun cours de votre part dans les deux prochaines semaines.',
    'nextClass.openLink': 'Ouvrir le lien de réunion',
    'nextClass.manage': 'Gérer la séance',
    'cohortSessions.attachRecording': 'Joindre l’enregistrement',
    'cohortSessions.changeRecording': 'Changer l’enregistrement',
    'cohortSessions.recording': 'Enregistrement',
    'cohortSessions.noRecording': 'Aucun',
    'cohortSessions.noRecordings': 'Aucune vidéo n’a encore été téléversée pour ce module dans cette cohorte. Ajoutez-la d’abord dans l’onglet Contenu.',
    'engagement.waitingOn': 'En attente de',
    'engagement.waitingQuiz': 'Le contrôle de « {lesson} »',
    'engagement.waitingSession': 'La session en direct de « {lesson} »',
    'lessons.requirement': 'Mode de diffusion',
    'lessons.requirementSelfPaced': 'À son rythme — un contenu travaillé seul',
    'lessons.requirementSynchronous': 'Session en direct — la cohorte s’y retrouve',
    'lessons.requirementSelfPacedHint': 'Porte des enregistrements, des lectures et des liens. Les apprenants avancent à leur rythme.',
    'lessons.requirementSynchronousHint': 'Chaque cohorte programme cette séance, et les leçons suivantes restent fermées jusqu’à sa tenue ; le contenu ajouté s’affiche sous la séance.',
    'lessons.liveBadge': 'Session en direct',
    'lessons.sessionSpecHint': 'Cette leçon EST la session — elle ne porte aucun contenu. Planifiez-la depuis l’onglet Sessions de la cohorte.',
    'lessons.sessionObjectives': 'Ce que couvre la session',
    'lessons.sessionObjectivesHint': 'L’ordre du jour du rassemblement. Identique dans chaque cohorte — seule la date change.',
    'lessons.sessionPreparation': 'Ce que les apprenants apportent',
    'lessons.sessionPreparationHint': 'Affiché sur la carte de session avant le cours, le seul moment où cela aide.',
    'lessons.expectedDuration': 'Durée prévue (minutes)',
    'lessons.expectedDurationHint': 'Pré-remplit le formulaire de planification. Le formateur peut l’allonger ou l’écourter.',
    'lessons.requiresAttendance': 'Présence',
    'lessons.attendanceOptional': 'Facultative — la session ouvre les leçons suivantes pour tout le monde',
    'lessons.attendanceRequired': 'Requise pour continuer',
    'lessons.attendanceRequiredHint': 'Les leçons suivantes s’ouvrent seulement aux présents, ou à tous dès que la séance a un enregistrement.',
    'lessons.requiresAttendanceOnHint': 'Les leçons suivantes ouvrent PAR APPRENANT, selon la feuille de présence — un cours manqué ne se rattrape pas, alors corrigez-la ou reprogrammez la session.',
    'lessons.requiresAttendanceOffHint': 'Marquer la session tenue ouvre les leçons suivantes pour toute la cohorte d’un coup.',
    'lessons.quizMarking': 'Réponses libres du quiz corrigées par',
    'lessons.quizMarkingHint': 'Les questions à choix sont toujours notées automatiquement. Ceci détermine qui corrige les réponses écrites.',
    'lessons.quizMarkingAiBadge': 'Corrigé par l’IA',
    'lessons.quizMarkingInstructorBadge': 'Corrigé par l’instructeur',
    'markingMode.instructor': 'Instructeur',
    'markingMode.ai': 'IA',
    'markingMode.assessmentAi': 'IA (propose une note ; un instructeur confirme toujours)',
    'markingMode.aiNotConfigured': 'La correction par IA n’est pas configurée.',
    'learn.lockedByAttendance': 'Vous n’êtes pas marqué comme ayant assisté à {lesson}. Voyez avec votre formateur — il peut corriger la feuille de présence ou refaire la session.',
    'cohortSessions.register': 'Feuille de présence',
    'cohortSessions.registerHint': 'Tout le monde est marqué présent quand vous tenez la session. Décochez les absents.',
    'cohortSessions.present': 'Présent',
    'cohortSessions.saveRegister': 'Enregistrer la feuille',
    'cohortSessions.registerSaved': 'Feuille enregistrée.',
    'cohortSessions.noRoster': 'Personne n’est encore inscrit à cette cohorte.',
    'learn.openAssessmentFlow': 'Ouvrir mon dossier d’inscription',

    // L’onglet Engagement du formateur sur CohortDetail (phase 7). Deux
    // colonnes de progression, jamais fusionnées.
    'engagement.statEnrolled': 'Inscrits',
    'engagement.statActive': 'Actifs',
    'engagement.statFinished': 'Terminés',
    'engagement.modulePicker': 'Module',
    'engagement.progress': 'Progression',
    'engagement.learner': 'Apprenant',
    'engagement.recorded': 'Enregistrée',
    'engagement.selfReported': 'Déclarée',
    'engagement.noLessons': 'Aucune leçon pour l’instant',
    'engagement.noEnrollments': 'Aucune inscription',
    'engagement.noEnrollmentsHint': 'Personne n’est encore inscrit à cette promotion.',
    'engagement.loadMore': 'Charger plus',
    'engagement.quizzes': 'Auto-évaluations',
    'engagement.quizPicker': 'Auto-évaluation',
    'engagement.noQuizzes': 'Aucune auto-évaluation sur ce module',
    'engagement.noQuizzesHint': 'Les quiz se rédigent sur l’écran du module ; les résultats apparaissent ici une fois que les apprenants les ont passés.',
    'engagement.noAttempts': 'Aucune tentative pour l’instant',
    'engagement.noAttemptsHint': 'Une fois que les apprenants auront passé cette auto-évaluation, le taux de bonnes réponses par question montrera quels sujets sont acquis.',
    'engagement.noAttemptsShort': 'aucune tentative',
    'engagement.correctRate': '{pct} % de bonnes réponses',
    'engagement.attempts': 'Tentatives',
    'engagement.best': 'Meilleur',
    'engagement.state': 'État',
    'engagement.quizStateAwaiting': 'En attente de correction',
    'engagement.quizStateMarkedByAi': 'Corrigé par l’IA',
    'engagement.quizStateMarkedByInstructor': 'Corrigé par le formateur',
    'engagement.lastAttempt': 'Dernière tentative',
    'engagement.submissions': 'Rendus',
    'engagement.noSubmissions': 'Aucun rendu',
    'engagement.noSubmissionsHint': 'Les évaluations ouvertes pour cette promotion apparaissent ici avec leur état.',
    'engagement.fileMissing': 'Fichier requis, aucun joint',
    'engagement.tutorQuestions': 'Questions au tuteur',
    'engagement.tutorQuestionsHint': "Leçons dont le contenu ne couvrait pas ce que les apprenants ont demandé.",
    'engagement.tutorLesson': 'Leçon',
    'engagement.tutorQuestionsCount': 'Questions',
    'engagement.tutorNotCovered': 'Non couvert',
    'engagement.noTutorQuestionsTitle': 'Aucune question au tuteur pour le moment',
    'engagement.noTutorQuestionsHint': 'Dès que des apprenants questionnent le tuteur, leurs questions sont comptées ici.',
    'engagement.actions': 'Actions',
    'engagement.message': 'Message',
    'engagement.messageTitle': 'Contacter {name}',
    'engagement.messageHint': "Le seul canal dont cette application dispose pour la joindre : sa propre adresse e-mail.",
    'engagement.noEmail': 'Aucun e-mail enregistré pour cette personne.',

    // ─── Public landing page ─────────────────────────────────────────────────
    // See en.js for the line between this dictionary and
    // src/content/landing/fr.js: controls here, prose there.
    // THE PUBLIC PAGES' OWN NAME, on the landing header and footer lockups
    // only. `app.name` stays the product's name inside the application; the
    // marketing site is sold as the VDC Academy.
    'landing.brandName': 'VDC Academy',
    'landing.skipToContent': 'Aller au contenu',
    'landing.sectionsNavLabel': 'Sections de la page',
    'landing.openMenu': 'Ouvrir le menu',
    'landing.closeMenu': 'Fermer le menu',
    'landing.goToPortal': 'Accéder au portail',
    'landing.cta.primary': 'Demander un programme de formation sur mesure',
    'landing.cta.secondary': 'Explorer le cursus',
    'landing.cta.plan': 'Demander un devis',
    'landing.pillars.modules': '{count} modules',
    'landing.pillars.modulesOne': '1 module',
    'landing.framework.level': 'Niveau {ordinal}',
    'landing.curriculum.noModules': 'Les modules de ce niveau sont en cours de finalisation.',
    'landing.footer.linksTitle': 'Liens utiles',
    'landing.backToTop': 'Retour en haut',
    'landing.form.name': 'Nom complet',
    'landing.form.email': 'E-mail professionnel',
    'landing.form.organisation': 'Organisation',
    'landing.form.phone': 'Téléphone',
    'landing.form.programmes': 'Programmes qui vous intéressent',
    'landing.form.programmesHint': 'Facultatif — cochez les programmes pour lesquels vous souhaitez un devis.',
    'landing.form.role': 'Votre fonction',
    'landing.form.country': 'Pays',
    'landing.form.countrySelect': 'Choisir un pays…',
    'landing.form.countryHint': 'Pour orienter votre demande vers la bonne équipe.',
    'landing.form.seats': 'Nombre de places envisagé',
    'landing.form.seatsUnspecified': 'Pas encore déterminé',
    'landing.form.updates': 'Tenez-moi informé par e-mail des nouveaux programmes et des dates de cohortes. Désabonnement possible à tout moment.',
    'landing.form.submit': 'Envoyer la demande',
    'landing.form.acknowledged': 'Merci — votre demande est bien parvenue à notre équipe. Nous répondrons à l’adresse indiquée. Rien n’est créé pour vous tant que nous ne nous sommes pas parlé.',
    'intake.sending': 'Envoi en cours…',
    'intake.failed': 'Votre demande ne nous est pas parvenue et rien n’a été enregistré. Réessayez dans un instant.',
    'intake.failedThrottled': 'Trop de demandes depuis cette connexion. Patientez une minute puis renvoyez-la.',
    'intake.captchaPending': 'Complétez la vérification ci-dessus pour envoyer votre demande.',
    'intake.captchaUnavailable': "La vérification de sécurité n'a pas pu se charger. Une extension de navigateur ou un bloqueur de publicités en est la cause habituelle ; désactivez-le pour cette page, ou écrivez-nous directement.",
    'intake.failedCaptcha': "La vérification de sécurité a expiré avant l'envoi de votre demande. Rien n'a été perdu — recommencez-la puis renvoyez.",
    'landing.backToSite': 'Retour à la page d’accueil',
    // Les arrivées propres à l'Académie : des adhésions achetées sur la page
    // publique. Personne ne s'est porté garant — la ligne porte une commande
    // et aucune personne, et l'admettre est un acte du coordinateur.
    'arrivals.academy': 'Commandes Academy',
    'arrivals.order': 'Commande',
    'arrivals.quoted': 'Devis, non débité',
    'arrivals.admit': 'Admettre',
    'arrivals.admitted': '{name} figure maintenant au registre. Délivrez ses accès ci-dessous.',
    'arrivals.awaitingAdmission': 'Admission échouée — admettre à la main',
    'arrivals.academyEmpty': 'Aucune adhésion n’a encore été achetée sur la page publique.',
    'arrivals.academyLead': 'Achetée sur la page publique. L’acheteur figure déjà au registre — vérifiez son identité, puis délivrez ses accès.',

    // ─── Adhésion et paiement de démonstration ───────────────────────────────
    // LE PAIEMENT NE PRÉLÈVE RIEN. Aucun prestataire derrière /subscribe : la
    // commande est enregistrée dans la file des arrivées et un coordinateur la
    // termine à la main. Chaque texte ci-dessous évite qu'un acheteur croie
    // avoir été débité ou qu'un accès l'attend déjà.
    'landing.membership.talkToUs': 'Parler à un coordinateur',
    'checkout.back': 'Retour au site',
    'checkout.title': 'Adhésion {tier}',
    'checkout.otherTiers': 'Autres adhésions',
    'checkout.seats': 'Sièges',
    'checkout.oneSeatOnly': 'Un siège — l’adhésion individuelle appartient à la personne qui la détient.',
    'checkout.seatsBounds': 'Entre {min} et {max} sièges',
    'checkout.volumeBreak': '{seats}+ sièges : {percent}% de remise',
    'checkout.programmes': 'Programmes',
    'checkout.subjects': 'Domaines',
    'checkout.allSubjects': 'Tous les domaines',
    'checkout.selectAll': 'Tout sélectionner',
    'checkout.clearAll': 'Effacer',
    'checkout.perSeat': '{price} par siège',
    'checkout.pickProgramme': 'Choisissez au moins un programme — un siège coûte les programmes qu’il couvre.',
    'checkout.noProgrammesForTier': 'Aucun programme n’est encore en vente avec cette adhésion. Contactez-nous et nous vous ferons un devis.',
    'checkout.programmesHint': 'Chaque programme coché ajoute son prix à chaque siège. Un coordinateur confirme l’adéquation avant toute inscription.',
    'checkout.details': 'Qui achète',
    'checkout.detailsHint': 'Un coordinateur vérifie ces informations avant de délivrer vos accès : un numéro joignable est utile.',
    'checkout.summary': 'Votre commande',
    'checkout.seatsLine': '{seats} × {price}',
    'checkout.volumeDiscount': 'Remise volume ({seats}+ sièges, {percent}%)',
    'checkout.promoDiscount': 'Promotion {code} ({percent}%)',
    'checkout.vat': 'TVA ({percent}%)',
    'checkout.pricing': 'Calcul de votre total…',
    'checkout.priceUnavailable': "Nous n'avons pas pu chiffrer cette commande pour le moment. Réessayez dans un instant.",
    'checkout.redirectNotice': "Vous allez être redirigé vers notre prestataire de paiement pour régler en toute sécurité. Votre adhésion démarre dès qu'il confirme le paiement — nous ne voyons jamais vos données bancaires.",
    'checkout.pay': 'Payer {total}',
    'checkout.paying': 'Redirection vers le paiement…',
    'checkout.failed': "Votre commande ne nous est pas parvenue et rien n'a été débité. Réessayez dans un instant.",
    'checkout.paymentsUnavailable': "Le paiement est indisponible pour le moment et rien n'a été débité. Contactez-nous et nous enregistrerons votre commande manuellement.",
    // ── Vérification de la boîte mail, entre le formulaire et la page de paiement.
    'checkout.verify.title': 'Vérifiez votre messagerie',
    'checkout.verify.body': "Nous avons envoyé un code à six chiffres à {email}. Saisissez-le pour passer au paiement.",
    'checkout.verify.label': 'Code de vérification',
    'checkout.verify.submit': 'Passer au paiement',
    'checkout.verify.checking': 'Vérification…',
    'checkout.verify.resend': 'Envoyer un nouveau code',
    'checkout.verify.resent': 'Un nouveau code est en route.',
    'checkout.verify.wrong': "Ce code n'est pas correct, ou il a expiré. Consultez le dernier message ou demandez un nouveau code.",
    'checkout.verify.locked': 'Trop de tentatives avec ce code. Demandez-en un nouveau.',
    'checkout.verify.resendLimit': "Un code vient d'être envoyé. Attendez une minute avant de redemander — et après trois codes, recommencez la commande.",
    'checkout.verify.expired': "Cette commande a expiré et rien n'a été débité. Veuillez recommencer.",
    'checkout.confirmedTitle': 'Paiement confirmé',
    'checkout.orderRef': 'Référence de commande',
    'checkout.total': 'Total',
    // ── La page de retour. Quatre situations, et L'ATTENTE N'EST PAS L'UNE DES
    // MAUVAISES : la redirection et la confirmation du prestataire se courent
    // après, donc « nous attendons » est l'état initial ordinaire — le texte ne
    // s'en excuse pas et ne laisse pas entendre qu'un problème est survenu.
    'checkout.returnWaitingTitle': 'En attente de votre paiement',
    'checkout.returnWaitingLead': "Votre banque confirme le paiement. Cela prend généralement quelques secondes — vous pouvez laisser cette page ouverte.",
    'checkout.returnStillWaitingLead': "Nous n'avons pas encore de réponse, ce qui ne signifie pas qu'il y a un problème : une confirmation peut prendre quelques minutes. Conservez votre référence de commande, nous vous écrirons dès réception.",
    'checkout.returnPaidLead': 'Merci — votre adhésion est réglée. Conservez votre référence de commande : c\'est ainsi que nous vous retrouvons.',
    'checkout.returnClosedTitle': 'Cette commande est clôturée',
    'checkout.returnClosedLead': "Le devis de cette commande a expiré ou elle a été annulée ; rien n'a été débité. Repartez de la page des adhésions et nous vous ferons un nouveau devis.",
    'checkout.returnRefundedTitle': 'Cette commande a été remboursée',
    'checkout.returnRefundedLead': "Le paiement de cette commande a été restitué. Si ce n'est pas ce que vous attendiez, contactez-nous en indiquant votre référence de commande.",
    'checkout.returnUnknownTitle': 'Commande introuvable',
    'checkout.returnUnknownLead': "Le lien a peut-être été raccourci ou mal saisi. Si vous avez une référence de commande, contactez-nous en l'indiquant — rien n'est perdu.",
    'checkout.promo': 'Code promotionnel',
    'checkout.promoPlaceholder': 'Saisir un code',
    'checkout.promoApply': 'Appliquer',
    'checkout.promoApplied': '{code} appliqué',
    'checkout.promoUnknown': 'Ce code ne nous dit rien.',
    'checkout.emailNotice': 'Un coordinateur vérifiera vos informations et vous enverra vos accès par e-mail. Rien d’autre n’est attendu de vous : il n’y a pas encore de compte à configurer.',

    // The renewal page — screens/subscribe/Renew.jsx. Where the renewal
    // letter sends a member; it asks the Academy what the order is and, on
    // a click, for the provider's page. Nothing is charged unattended.
    'renew.title': 'Renouvelez votre adhésion',
    'renew.lead': 'Votre période d’adhésion arrive à échéance. Renouvelez-la pour une nouvelle période au tarif ci-dessous : même formule, mêmes places.',
    'renew.loadingTitle': 'Recherche de votre renouvellement…',
    'renew.loadingLead': 'Un instant, nous retrouvons la commande indiquée dans votre courrier.',
    'renew.paidTitle': 'Votre adhésion est renouvelée',
    'renew.paidLead': 'Ce renouvellement a été réglé et votre période a été prolongée. Rien d’autre n’est attendu de vous.',
    'renew.closedTitle': 'Cette offre de renouvellement est close',
    'renew.closedLead': 'Le tarif de votre courrier était garanti jusqu’à une date désormais passée ; rien n’a été prélevé. Contactez-nous en indiquant votre référence de commande et nous vous renouvellerons manuellement.',
    'renew.unknownTitle': 'Nous ne trouvons pas ce renouvellement',
    'renew.unknownLead': 'Le lien a peut-être été tronqué ou mal saisi. Si vous avez une référence de commande, contactez-nous en l’indiquant : rien n’est perdu.',
    'renew.plan': 'Adhésion',
    'renew.termEnds': 'Fin de la période actuelle',
    'renew.renewsUntil': 'Renouvelée jusqu’au',
    'renew.priceHeldUntil': 'Tarif garanti jusqu’au',
    'renew.nothingCharged': 'Rien n’est prélevé sans votre décision. Nous ne conservons aucune carte : si vous ne faites rien, votre adhésion prend simplement fin à la date ci-dessus et rien ne vous sera facturé.',
    'renew.failed': 'Impossible d’ouvrir la page de paiement pour le moment ; rien n’a été prélevé. Réessayez dans un instant.',

    // ─── Comptes entreprise (B2B) ───────────────────────
    // « Place » signifie une INSCRIPTION, pas une personne : une entreprise
    // achète vingt places et en dépense une chaque fois que quelqu’un rejoint
    // une cohorte ; un retrait la restitue.
    'nav.company': 'Mon entreprise',
    'nav.companies': 'Entreprises',

    'company.title': 'Entreprise',
    'company.titleUniversity': 'Université',
    'company.subtitle': 'Vos places, vos apprenants et les cohortes qui vous ont été vendues.',
    'company.noAccount': 'Aucune entreprise n’est liée à votre compte',
    'company.noAccountHint': 'Votre fiche Académie n’est rattachée à aucune entreprise, donc aucune place à afficher — demandez à votre contact de la rattacher.',

    'company.seatsBought': 'Places achetées',
    'company.seatsUsed': 'Places utilisées',
    'company.seatsLeft': 'Places restantes',
    'company.seatsLeftHint': 'Une place se dépense en inscrivant et se restitue en retirant.',
    'company.allowance': 'Quota de places',
    'company.allowanceSpent': 'Toutes vos places sont utilisées. Retirez un apprenant d’une cohorte pour en libérer une, ou parlez-en à votre contact Académie pour en acheter d’autres.',
    'company.learners': 'Apprenants',
    'company.ourLearners': 'Les vôtres',

    'company.cohorts': 'Vos cohortes',
    'company.noCohorts': 'Aucune cohorte pour l’instant',
    'company.noCohortsHint': 'Les cohortes apparaissent ici dès que l’Académie en programme une sur votre compte.',

    'company.noLearners': 'Personne n’a encore été ajouté',
    'company.noLearnersHint': "Ajoutez les personnes que vous voulez former. Nommer quelqu'un ne coûte aucune place — une place est utilisée lorsque vous l'inscrivez.",
    'company.people': 'Personnes',
    'company.peopleHint': 'Nommées sur votre compte. Nommer ne coûte aucune place.',
    'company.accountHolder': 'Titulaire du compte :',
    'company.accountHolderAlsoLearner': 'également inscrit',
    'company.addPerson': 'Ajouter une personne',
    'company.addPersonHint': "Elles pourront être inscrites une fois ajoutées. Ajouter quelqu'un n'utilise aucune place — une place est utilisée lors de l'inscription à une promotion.",
    'company.signIn': 'Connexion',
    'company.hasSignIn': 'Émis',
    'company.loginIssuedBy': 'Émis par {name} le {date}',
    'company.seatsHeld': 'Places occupées',
    'company.seatsHeldCount': '{count} place(s)',
    'company.lastEnrolled': 'Dernière inscription',
    'company.enrollable': 'Inscriptible',
    'company.notEnrollable': 'Pas encore',
    'company.issueLogin': 'Demander un acc\u00e8s',
    'company.signInRequestedFor': 'Un acc\u00e8s a \u00e9t\u00e9 demand\u00e9 pour {name}.',
    'company.signInRequestedHint': 'Un lien pour choisir leur propre mot de passe leur sera envoy\u00e9. Personne ici ne le voit.',
    'company.signInRequested': 'Un acc\u00e8s a \u00e9t\u00e9 demand\u00e9. Un lien pour choisir leur mot de passe leur sera envoy\u00e9.',
    'company.loginIssued': 'Peut se connecter',
    'company.organisation': 'Organisation',
    'company.organisationHint': 'Vous gérez plusieurs organisations. Choisissez celle à consulter.',
    'company.manager': 'Gestionnaire',
    'company.managerAria': 'Désigner {name} comme gestionnaire',
    'company.managerHint': 'Un gestionnaire ouvre le portail de l’entreprise à cette personne. Seul un administrateur de l’Académie désigne qui gère une organisation.',
    // ─── Le poste de pilotage du portail client ──────────────────────────────
    // Neuf sections, et les mots sont ceux du client, pas ceux du schéma : ce
    // lecteur n'a jamais vu une « inscription » ni une « bande de maîtrise »
    // nommées ainsi. Les libellés disent ce que la chose est POUR LUI.
    //
    // La distinction place/personne survit à chaque ligne : une place se
    // dépense en inscrivant et revient en retirant ; nommer quelqu'un ne coûte
    // rien.
    'nav.group.company': 'Mon entreprise',
    'nav.companyProgrammes': 'Programmes',
    'nav.companyProgrammes.what': 'Ce qui vous a été vendu',
    'nav.companyCohorts': 'Cohortes',
    'nav.companyCohorts.what': 'Quand vos formations tournent',
    'nav.companyPeople': 'Personnes',
    'nav.companyPeople.what': 'Qui vous pouvez envoyer',
    'nav.companyEnrollments': 'Places utilisées',
    'nav.companyEnrollments.what': 'Qui est sur quelle cohorte',
    'nav.companyRequests': 'Demandes',
    'nav.companyRequests.what': 'Nous demander une session',
    'nav.companyLearning': 'Apprentissage',
    'nav.companyLearning.what': 'Où en sont les modules',
    'nav.companyReadiness': 'Préparation',
    'nav.companyReadiness.what': 'Qui est prêt, et à quel point',
    'nav.companyAttendance': 'Présence',
    'nav.companyAttendance.what': 'Qui est venu',

    'company.signals': 'À regarder',
    'company.signal.notStarted': 'n’ont pas commencé',
    'company.signal.notStartedHint': 'Ces places sont payées et intactes — pas une leçon, pas une tentative.',
    'company.signal.notStartedCta': 'Voir qui',
    'company.signal.noSignIn': 'ne peuvent pas encore se connecter',
    'company.signal.noSignInHint': 'Ils sont sur votre compte mais sans accès : ils ne voient rien de ce que vous avez acheté.',
    'company.signal.noSignInCta': 'Créer les accès',
    'company.signal.openRequests': 'chez nous',
    'company.signal.openRequestsHint': 'Demandes de cohorte auxquelles nous n’avons pas encore répondu.',
    'company.signal.openRequestsCta': 'Voir vos demandes',
    'company.signal.allowanceSpent': 'places, toutes utilisées',
    'company.signal.allowanceSpentCta': 'Voir qui les occupe',

    'company.activity': 'Activité',
    'company.modulesPassed': 'Modules réussis',
    'company.modulesPassedHint': 'Pour l’ensemble des personnes inscrites.',
    'company.modulesInProgress': 'Modules en cours',
    'company.credentialsHeld': 'Certificats détenus',
    'company.credentialsHeldHint': 'Actifs au registre public.',
    'company.attendanceRate': 'Présence',
    'company.attendanceRateHint': 'Sur les séances dont la feuille a été faite.',
    'company.attendanceUnknown': 'Aucune feuille de présence',
    'company.hoursDelivered': 'Heures dispensées',
    'company.hoursDeliveredHint': 'Sur {held} séances tenues pour vous.',
    'company.hoursAttended': 'Heures suivies',
    'company.hoursAttendedHint': 'Suivies par vos propres collaborateurs.',
    'company.hoursScheduled': 'Heures programmées',
    'company.hoursScheduledHint': '{ahead} séances encore à tenir — pas encore dispensées.',
    'company.enrollmentStates': 'Places par état',
    'company.enrollmentStatesHint': 'Les places retirées sont comptées ici et pas dans « places utilisées » — une place rendue explique une baisse.',
    'company.noEnrollmentsYet': 'Personne n’est encore inscrit.',
    'company.whatsNext': 'Où regarder ensuite',
    'company.goLearning': 'Où en sont les modules',
    'company.goReadiness': 'Qui est prêt',
    'company.goAttendance': 'Présence — {count} séance(s) à venir',

    'company.peopleLead': 'Les personnes que vous pouvez envoyer en formation. Nommer quelqu’un ne coûte aucune place ; une place se dépense à l’inscription.',
    'company.peopleTotal': 'Personnes nommées',
    'company.peopleTotalHint': 'Sur votre liste, inscrites ou non.',
    'company.peopleWithSignIn': 'Peuvent se connecter',
    'company.peopleWithoutSignIn': 'Pas encore de connexion',
    'company.peopleWithoutSignInHint': 'Sur votre compte mais ne voient rien de ce que vous avez acheté.',
    'company.peopleEnrollable': 'Prêtes à inscrire',
    'company.peopleEnrollableHint': 'Ont un profil apprenant et peuvent être ajoutées à une cohorte.',
    'company.cohortsLead': 'Les sessions réservées sur votre compte. Une cohorte encore vide est déjà la vôtre — remplissez-la depuis Places utilisées.',
    'company.cohortsTotal': 'Cohortes réservées',
    'company.cohortsRunning': 'En cours',
    'company.cohortsOpenToEnrol': 'Encore de la place',
    'company.cohortsOpenToEnrolHint': 'Peuvent encore accueillir vos personnes.',
    'company.cohortsOurLearners': 'Vos places sur les cohortes',

    'company.programmes': 'Programmes',
    'company.programmesLead': 'Ce que votre offre validée nomme. Ce n’est pas tout notre catalogue : c’est ce qui vous a été vendu.',
    'company.noProgrammes': 'Aucun programme n’est encore rattaché à votre compte',
    'company.verifiedPath': 'Confirmé',
    'company.verified': 'Confirmé avec vous',
    'company.asRequested': 'Tel que demandé',
    'company.programmesToRequests': 'Nous demander d’en lancer un',
    'company.programmesTotal': 'Programmes proposés',
    'company.programmesConfirmedCount': 'Confirmés avec vous',
    'company.programmesAsRequestedCount': 'Tels que demandés',

    'company.enrollments': 'Places utilisées',
    'company.enrollmentsLead': 'Une ligne par place dépensée, et ce qu’elle a donné. Les retraits restent affichés : ils ne coûtent rien, et ils expliquent une baisse.',
    'company.noEnrollments': 'Aucune place utilisée',
    'company.noEnrollmentsHint': 'Inscrivez quelqu’un de vos personnes dans une de vos cohortes ci-dessous.',
    'company.enrolledAt': 'Inscrit le',
    'company.progress': 'Avancement',
    'company.modulesOf': '{passed} module(s) réussi(s) sur {total}',
    'company.lastPassed': 'Dernière réussite',
    'company.enrollmentsTotal': 'Places dépensées',
    'company.enrollmentsActive': 'Actives',
    'company.enrollmentsCompleted': 'Terminées',
    'company.enrollmentsWithdrawn': 'Retirées',
    'company.enrollmentsWithdrawnHint': 'Ne coûtent rien — expliquent une baisse d’usage.',

    'company.learning': 'Apprentissage',
    'company.learningLead': 'Par module plutôt que par personne : quarante barres ne disent rien, « onze bloquent sur le même module » dit quoi faire.',
    'company.noLearning': 'Rien à signaler pour l’instant',
    'company.noLearningHint': 'Dès que vos personnes sont inscrites et leurs modules ouverts, cette page se remplit seule.',
    'company.module': 'Module',
    'company.onThisModule': 'Personnes concernées',
    'company.averageProgress': 'Avancement moyen',
    'company.spread': 'Où ils en sont',
    'company.spreadNotStarted': '{count} pas commencé',
    'company.spreadInProgress': '{count} en cours',
    'company.spreadPassed': '{count} réussi',
    'company.spreadFailed': '{count} échoué',
    'company.averageScore': 'Note moyenne',
    'company.notGradedYet': 'Pas encore corrigé',
    'company.notAssessed': 'Non évalué',
    'company.learningModulesTotal': 'Modules en cours',
    'company.learningNotStartedTotal': 'Pas encore commencés',
    'company.learningPassedTotal': 'Réussis',
    'company.learningFailedTotal': 'Échoués',

    'company.readiness': 'Préparation',
    'company.readinessLead': 'Trois choses différentes, côte à côte : ce qu’ils ont parcouru, ce qu’ils ont réussi, et où cela les situe.',
    'company.noReadiness': 'Personne n’est encore inscrit',
    'company.noReadinessHint': 'La préparation apparaît dès que vos personnes sont sur une cohorte et que leurs travaux sont corrigés.',
    'company.passedCredit': 'Réussi',
    'company.mandatory': 'Modules obligatoires',
    'company.mandatoryDone': 'Tous réussis',
    'company.mandatoryOpen': 'Il en reste',
    'company.competencies': 'Compétences acquises',
    'company.readinessTotal': 'Personnes évaluées',
    'company.readinessMandatoryDoneCount': 'Tout le requis réussi',
    'company.readinessAvgPassedCredit': 'Réussite moyenne',
    'company.readinessMeetsBarCount': 'Atteignent le seuil',
    'company.readinessMeetsBarHint': 'Prêts pour le titre de leur programme.',
    'company.unmetModules': 'Modules en attente',

    'company.attendanceLead': 'Relevée en classe par le formateur, comme une feuille de présence. Rien ici n’est mesuré depuis un écran, et cela peut être corrigé.',
    'company.noSessions': 'Aucune séance programmée',
    'company.noSessionsHint': 'Les séances en direct apparaissent dès que votre cohorte en a au calendrier.',
    'company.sessions': 'Séances',
    'company.when': 'Quand',
    'company.session': 'Séance',
    'company.ourAttendance': 'Vos personnes',
    'company.notHeldYet': 'Pas encore tenue',
    'company.registerNotTaken': 'Feuille non faite',
    'company.presentOf': '{present} présent(s) sur {enrolled}',
    'company.attendanceByPerson': 'Par personne',
    'company.sessionsExpected': 'Séances attendues',
    'company.sessionsAttended': 'Présences',

    'person.phone': 'Téléphone',
    'program.code': 'Code',
    'common.copy': 'Copier',
    'common.copied': 'Copié',
    'common.done': 'Terminé',

    // ─── Placement en promotion ──────────────────────────────────────────────
    'placement.action': 'Placer en promotion',
    'placement.title': 'Placer {subject} en promotion',
    'placement.confirmedProgramme': 'Programme confirmé',
    'placement.programmeUnknown': 'Non reconnu',
    'placement.confirmedSeats': '{count} places confirmées',
    'placement.inferred': 'Déduit des modules demandés — ce programme en couvre {matched} sur {requested}. Non couvert : {uncovered}.',
    'placement.unrecognised': 'L’offre demande {codes}, que ce catalogue ne vend pas. Vérifiez l’offre dans avant de placer qui que ce soit.',
    'placement.noOffer': 'Aucune offre confirmée pour ce client — il n’est pas issu d’une affaire gagnée. Choisissez une promotion dans le registre.',
    'placement.who': 'Placement de {count}',
    'placement.notEnrollable': 'Pas de profil apprenant',
    'placement.candidates': 'Promotions correspondantes',
    'placement.noCandidates': 'Aucune promotion ouverte pour ce programme — démarrez-en une ci-dessous.',
    'placement.otherMarket': 'Autre pays',
    'placement.alreadyThere': 'Déjà inscrit',
    'placement.place': 'Placer ici',
    'placement.notEnoughSeats': 'Seulement {available} places libres, {needed} nécessaires.',
    'placement.startNew': 'Démarrer une promotion',
    'placement.newCohort': 'Nouvelle promotion pour {programme}',
    'placement.newCohortHint': 'Programme, marché et places viennent de l’affaire confirmée ; le curriculum {version} est figé à la création. Nommez-la et datez-la.',
    'placement.createAndPlace': 'Créer et placer {count}',

    // ─── Demandes de promotion ──────────────────────────────────────────────
    'cohortRequest.title': 'Demandes de promotion',
    'cohortRequest.lead': 'Dites-nous quel programme vous voulez lancer et à peu près quand. Nous réservons le formateur et démarrons la promotion, puis vous remplissez ses places vous-même.',
    'cohortRequest.ask': 'Demander une promotion',
    'cohortRequest.programme': 'Programme',
    'cohortRequest.pickProgramme': 'Choisissez un programme…',
    'cohortRequest.seats': 'Places à utiliser',
    'cohortRequest.seatsHint': 'Il vous en reste {count}.',
    'cohortRequest.preferredStart': 'Début souhaité',
    'cohortRequest.note': 'Ce que nous devrions savoir',
    'cohortRequest.send': 'Envoyer la demande',
    'cohortRequest.none': 'Aucune demande pour l’instant.',
    'cohortRequest.noProgrammes': "Votre offre ne nomme pas encore de programme correspondant à notre catalogue. Votre contact Académie peut confirmer ce qui a été convenu.",
    'cohortRequest.noSeats': 'Toutes vos places sont utilisées. Contactez-nous avant de demander une autre promotion.',
    'cohortRequest.waiting': 'Chez l’Académie',
    'cohortRequest.fulfilled': 'Promotion lancée',
    'cohortRequest.declined': 'Refusée',
    'cohortRequest.summary': '{seats} places · début souhaité {when}',
    'cohortRequest.noPreference': 'sans préférence',
    'cohortRequest.queueLead': 'Des entreprises demandent le lancement d’une promotion. Lancez-la, ou expliquez pourquoi non.',
    'cohortRequest.openTab': 'Ouvertes',
    'cohortRequest.allTab': 'Toutes',
    'cohortRequest.queueEmpty': 'Aucune demande de promotion',
    'cohortRequest.queueEmptyHint': 'Quand une entreprise avec des places en demande une, elle arrive ici.',
    'cohortRequest.asking': 'Demande {seats} places · début souhaité {when}',
    'cohortRequest.askedBy': 'Demandé par {who} · {when}',
    'cohortRequest.fulfil': 'Lancer la promotion',
    'cohortRequest.decline': 'Refuser',
    'cohortRequest.fulfilTitle': 'Répondre à {company}',
    'cohortRequest.fulfilHint': 'Indiquez la promotion que vous avez lancée pour eux. Pas encore créée ?',
    'cohortRequest.createCohort': 'En créer une',
    'cohortRequest.cohort': 'Promotion',
    'cohortRequest.pickCohort': 'Choisissez une promotion…',
    'cohortRequest.noteToCompany': 'Note à l’entreprise',
    'cohortRequest.declineTitle': 'Refuser {company}',
    'cohortRequest.reason': 'Motif',
    'cohortRequest.reasonHint': 'L’entreprise le verra.',

    // ─── Notifications en direct ─────────────────────────────────────────────
    'toast.crmArrival': 'Un nouveau client vient d’arriver.',
    'toast.viewPeople': 'Voir les personnes',

    'company.enrol': 'Inscrire des apprenants',
    'company.chooseCohort': 'Cohorte',
    'company.chooseCohortPlaceholder': 'Choisissez une de vos cohortes…',
    'company.noOpenCohorts': 'Aucune de vos cohortes n’a de place actuellement',
    'company.addLearner': 'Ajouter un apprenant',
    'company.noEnrollableLearners': 'Plus personne à ajouter',
    'company.enrolSubmit': 'Inscrire {count} apprenant(s)',

    'company.name': 'Entreprise',
    'company.segment': 'Segment',
    'company.kind': 'Type',
    'company.kind.company': 'Entreprise',
    'company.kind.university': 'Université',
    'company.kindHint': 'Défini par d’après ce que le client nous a indiqué ; corrigez-le ici si s’est trompé.',
    'company.seats': 'Places',
    'company.memberCount': 'Membres',
    'company.members': 'Membres de {name}',
    'company.status': 'Statut',
    'company.open': 'Ouvert',
    'company.closed': 'Fermé',
    'company.statTotal': 'Entreprises',
    'company.statActive': 'Actives',
    'company.statMembers': 'Membres',
    'company.statNoSeatsBought': 'Sans places achetées',
    'company.edit': 'Modifier l’entreprise',
    'company.noneYet': 'Aucun compte entreprise pour l’instant',
    'company.noneYetHint': 'Les comptes arrivent avec les contrats gagnés dans, ainsi que les places achetées par chacun.',
    'company.noSeatsBought': 'Aucune place achetée',
    'company.seatAllowance': 'Places achetées',
    'company.seatAllowanceFrozen': 'Fixé par le contrat gagné dans, et augmenté par le suivant. Non modifiable ici — les places sont ce que le client a acheté.',
    'company.crmAccountId': 'Identifiant du compte',
    'company.crmAccountFrozen': 'Figé après la création : c’est l’identité du compte, et le repointer déplacerait toute la liste des cohortes.',
    'company.active': 'Ouvert aux nouvelles inscriptions',
    'company.activeHint': 'La fermeture conserve tous les enregistrements et bloque les nouvelles inscriptions.',
    'company.noMembers': 'Personne dans cette entreprise pour l’instant',
    'company.noMembersHint': 'Les noms arrivent avec le contrat gagné, ou du gestionnaire de l’entreprise depuis son portail.',
    'company.rosterOwnerHint': 'Le contrat gagné nomme les personnes qu’il couvre, et le gestionnaire de l’entreprise ajoute les autres depuis son portail. Le personnel délivre ici les accès.',

    'error.seat_allowance': 'Cette entreprise n’a plus de place.',


    // ═══════════════════════════════════════════════════════════════════════
    // PORTÉE DU CURSUS — tout ce qui suit concerne LA MATIÈRE à laquelle une
    // chose appartient. Voir docs/MULTI-CURRICULUM.md.
    // ═══════════════════════════════════════════════════════════════════════

    'curriculum.levelTitle': 'Titre',
    'curriculum.editLevel': 'Modifier le niveau',
    'curriculum.editLevelHint': 'Tout est modifiable ici : un niveau n’a pas de code, et chaque exigence du système nomme un module.',
    'curriculum.deleteLevel': 'Supprimer le niveau',
    'curriculum.deleteLevelConfirm': 'Supprimer {title} ? Seul un niveau vide peut être retiré.',
    'curriculum.deleteLevelWhy': 'Supprimer un niveau emporte ses modules — et les leçons, quiz et exigences qui passent par eux. L’action n’est donc offerte que tant que le niveau est vide.',
    'curriculum.levelNotEmpty': 'Contient {count} module(s) — retirez-les d’abord pour supprimer ce niveau.',
    'curriculum.levelOrdinalTaken': 'Deux niveaux ne peuvent pas partager un rang. Déplacez l’autre d’abord.',

    'curriculum.createDimension': 'Nouvelle dimension',
    'curriculum.editDimension': 'Modifier la dimension',
    'curriculum.deleteDimension': 'Supprimer la dimension',
    'curriculum.deleteDimensionConfirm': 'Supprimer {name} ? Seule une dimension que rien ne référence peut être retirée.',
    'curriculum.dimensionCode': 'Code',
    'curriculum.dimensionCodeHint': 'Court, en majuscules et définitif dès la création — les étiquettes de modules et les piliers publics le nomment.',
    'curriculum.dimensionCodeLocked': 'Défini une fois, jamais modifié. Les étiquettes de modules et les outils de dimension le tiennent comme clé étrangère, et la page publique le nomme par son code — un renommage en repointerait certains et en orphelinerait d’autres, sans un mot.',
    'curriculum.dimensionName': 'Nom',
    'curriculum.dimensionContentCore': 'Cœur de contenu',
    'curriculum.dimensionContentCoreHint': 'Une ligne décrivant ce que couvre cet axe. C’est ce que la section des piliers publics imprime sous le nom.',
    'curriculum.dimensionOrdinal': 'Ordre d’affichage',
    'curriculum.dimensionTools': 'Outils canoniques',
    'curriculum.dimensionToolsHint': 'Ce sur quoi cet axe prétend être enseigné, par opposition aux outils d’un module, qui sont ce sur quoi on enseigne réellement.',
    'curriculum.dimensionsShared': 'Le vocabulaire vaut pour toute l’académie et ne se restreint pas au cursus ci-dessus : une dimension est nommée par son code depuis les étiquettes de modules et la page publique à la fois, donc deux matières ne peuvent pas avoir chacune leur « 3D ». Seuls les décomptes sont par cursus.',
    'curriculum.noDimensions': 'Aucune dimension',
    'curriculum.noDimensionsHint': 'Créez les axes dont le cursus étiquette ses modules.',
    'curriculum.dimensionInUse': 'Référencée par {count} module(s) — retirez d’abord l’étiquette de ceux-ci.',

    'curriculum.publicVersion': 'Page publique',
    'curriculum.publicVersionAuto': 'Automatique',
    'curriculum.publicVersionAutoHint': 'Aucune édition n’est épinglée : la page publique montre la plus récente en vigueur.',
    'curriculum.publicVersionPinnedHint': 'Épinglée sur {label}. La page publique montre cette édition au lieu d’en déduire une — tant qu’elle est en vigueur et non retirée.',
    'curriculum.setPublicVersion': 'Afficher ceci sur la page publique',
    'curriculum.clearPublicVersion': 'Revenir à l’automatique',
    'curriculum.publicVersionNotEffective': 'Épinglée, mais pas en vigueur aujourd’hui — la page publique montre une autre édition jusqu’à la date de celle-ci. Un épinglage ne publie jamais en avance.',
    'curriculum.pinnedBadge': 'Épinglée',

    'program.curriculum': 'Cursus',
    'program.curriculumHint': 'La matière dont ce programme est vendu — choisissez-la d’abord, car le lot de modules défini ensuite doit en provenir.',
    'program.curriculumLocked': 'Défini une fois. Déplacer un programme vers une autre matière laisserait derrière lui chaque module de son lot — et le lot est ce sur quoi une cohorte s’inscrit.',
    'program.pickCurriculumFirst': 'Choisissez un cursus pour créer un programme.',
    'program.noCurricula': 'Aucun cursus pour l’instant — créez-en un depuis l’écran Cursus. Un programme est vendu au sein d’une matière : il n’y a rien sous quoi le classer.',
    'program.allCurricula': 'Tous les cursus',
    'program.curriculumFilterHint': 'Les programmes de toutes les matières. Choisissez-en une pour ne voir que ce qu’elle vend.',



    // ── Le barème (la dernière écran de la phase 4 du plan 3) ────────────────
    'nav.priceBook': 'Barème',
    'nav.priceBook.what': 'Ce que coûte une adhésion, et chaque code de remise',
    'priceBook.lede': 'Ce que l’Académie facture pour une adhésion, par marché, et les codes qui la remisent. Changer un prix déplace ce qui sera proposé au prochain acheteur ; cela ne réécrit jamais une commande déjà payée.',
    'priceBook.tab.plans': 'Formules et prix',
    'priceBook.tab.promotions': 'Codes de remise',
    'priceBook.edit': 'Modifier',
    'priceBook.showRetired': 'Inclure les formules retirées',
    'priceBook.onSale': 'En vente',
    'priceBook.retired': 'Retirée',
    'priceBook.noDefaultPrice': 'Sans prix — pas en vente',
    'priceBook.retire': 'Retirer',
    'priceBook.restore': 'Rétablir',
    'priceBook.accountKind.person': 'Acheteur particulier',
    'priceBook.accountKind.company': 'Organisation',

    'priceBook.plan.create': 'Nouvelle formule',
    'priceBook.plan.edit': 'Modifier la formule',
    'priceBook.plan.createNote': 'Une nouvelle formule n’est pas en vente tant qu’elle n’a pas de devise par défaut et au moins un programme tarifé. Décider qu’une formule existe et décider de son prix sont deux actes distincts.',
    'priceBook.plan.code': 'Code',
    'priceBook.plan.codeHint': 'Le mot que la page d’accueil, l’écran des arrivées et trois langues emploieront pour cette formule. En minuscules.',
    'priceBook.plan.codeFixed': 'Figé : ce code figure sur chaque commande achetée sous cette formule.',
    'priceBook.plan.name': 'Nom',
    'priceBook.plan.accountKind': 'Acheteur',
    'priceBook.plan.accountKindHint': 'L’onglet de la file d’arrivées où atterrit un acheteur de cette formule. Non modifiable ensuite.',
    'priceBook.plan.accountKindFixed': 'Figé : le changer déplacerait des personnes déjà arrivées.',
    'priceBook.plan.minSeats': 'Places minimum',
    'priceBook.plan.maxSeats': 'Places maximum',
    'priceBook.plan.displayOrder': 'Ordre',
    'priceBook.plan.displayOrderHint': 'Sa place parmi les cartes d’adhésion.',
    'priceBook.plan.seatBand': 'De {min} à {max} places',
    'priceBook.plan.statTotal': 'Formules',
    'priceBook.plan.statOnSale': 'En vente',
    'priceBook.plan.statNoDefaultPrice': 'Sans prix',
    'priceBook.plan.statMarketOverrides': 'Exceptions de marché',
    'priceBook.plan.none': 'Aucune formule au barème',
    'priceBook.plan.noneHint': 'Rien n’est en vente tant qu’une formule n’existe pas avec un prix par défaut.',

    'priceBook.price.add': 'Ajouter un marché',
    'priceBook.price.edit': 'Modifier la devise et la taxe',
    'priceBook.price.market': 'Marché',
    'priceBook.price.marketHint': 'Laissez vide pour le prix par défaut — celui que paie tout marché sans prix local.',
    'priceBook.price.default': 'Par défaut',
    'priceBook.price.defaultOption': 'Par défaut (tout autre marché)',
    'priceBook.price.defaultNote': 'Le défaut est une ligne, pas un vide : la devise et la taxe de tout marché sans ligne propre. Une formule sans défaut n’est en vente nulle part. Le prix d’un siège se fixe par programme ci-dessous.',
    'priceBook.price.currency': 'Devise',
    'priceBook.price.currencyHint': 'Une nouvelle ligne est dans la devise choisie dans l’en-tête. Pour tarifer ce marché dans une autre devise, changez-la d’abord.',
    'priceBook.price.currencyStoredHint': 'La devise de cette ligne est fixée une fois enregistrée ; seule la taxe peut changer.',
    'publicPrice.approxTitle': 'Montant approximatif, au taux indicatif du jour. Vous serez débité de {price}.',
    'publicPrice.approxLabel': 'Prix approximatifs',
    'priceBook.price.unitPrice': 'Par place',
    'priceBook.price.unitPriceHint': 'Ce que ce programme ajoute à un siège, avant toute remise.',
    'priceBook.price.tax': 'Taxe',
    'priceBook.price.taxPercent': 'Taxe',
    'priceBook.price.taxPercentHint': 'Appliquée au total remisé et présentée à l’acheteur sur sa propre ligne.',
    'priceBook.price.none': 'Aucune devise définie — cette formule n’est pas en vente.',
    'priceBook.price.remove': 'Retirer la devise et la taxe de ce marché',
    'priceBook.programs.heading': 'Prix des programmes',
    'priceBook.programs.lede': 'Un siège coûte la somme des programmes cochés par l’acheteur. Un programme sans prix ici n’est pas vendu dans cette formule.',
    'priceBook.programs.add': 'Tarifer un programme',
    'priceBook.programs.edit': 'Modifier le prix du programme',
    'priceBook.programs.none': 'Aucun programme tarifé — cette formule n’est pas en vente.',
    'priceBook.programs.programme': 'Programme',
    'priceBook.programs.pick': 'Choisir un programme',
    'priceBook.programs.notFiled': 'non classé pour ce public',
    'priceBook.programs.remove': 'Retirer ce prix de programme',
    'priceBook.programs.marketHint': 'Laisser vide pour le défaut — le prix de ce programme sur tout marché sans prix propre.',
    'priceBook.programs.currencyNote': 'Exprimé en {currency}, la devise de cette formule sur ce marché.',
    'priceBook.programs.needsCurrency': 'Définissez d’abord la devise et la taxe par défaut de cette formule — un prix de programme s’exprime dans celle-ci.',
    'priceBook.breaks.button': 'Paliers de volume ({count})',
    'priceBook.breaks.title': 'Paliers de volume — {plan}',
    'priceBook.breaks.oneApplies': 'Un seul palier s’applique : le plus élevé que la commande atteint. Ils ne se cumulent jamais.',
    'priceBook.breaks.minSeats': 'À partir de',
    'priceBook.breaks.rate': 'Remise',
    'priceBook.breaks.add': 'Ajouter un palier',
    'priceBook.breaks.remove': 'Retirer ce palier',
    'priceBook.breaks.none': 'Aucun palier. Une formule vendue une place à la fois n’a pas de volume à remiser.',
    'priceBook.breaks.summary': 'Volume :',
    'priceBook.breaks.item': '{seats} places et plus, {rate} de remise',

    'priceBook.promo.create': 'Émettre un code',
    'priceBook.promo.edit': 'Modifier le code',
    'priceBook.promo.scopeNote': 'La portée se dit par l’absence : sans formule vaut toutes les formules, sans marché vaut tous les marchés. Laissez les deux pour un code de lancement ; restreignez-en un pour un partenariat.',
    'priceBook.promo.code': 'Code',
    'priceBook.promo.codeHint': 'Mis en majuscules à l’enregistrement, de sorte qu’une graphie fasse un seul code.',
    'priceBook.promo.codeFixed': 'Figé : ce code est nommé sur chaque commande chiffrée avec lui.',
    'priceBook.promo.rate': 'Remise',
    'priceBook.promo.rateHint': 'Sur le sous-total. Jamais composée avec un palier de volume — les deux se retranchent du même chiffre.',
    'priceBook.promo.from': 'Du',
    'priceBook.promo.to': 'Dernier jour',
    'priceBook.promo.windowHint': 'Vide signifie depuis toujours.',
    'priceBook.promo.toHint': 'Le dernier jour où il fonctionne. Vide signifie jusqu’à nouvel ordre.',
    'priceBook.promo.plan': 'Formule',
    'priceBook.promo.planHint': 'L’adhésion à laquelle il s’applique.',
    'priceBook.promo.everyPlan': 'Toutes les formules',
    'priceBook.promo.market': 'Marché',
    'priceBook.promo.marketHint': 'Un code restreint à un marché est refusé sur un devis qui n’a pas nommé de pays.',
    'priceBook.promo.everyMarket': 'Tous les marchés',
    'priceBook.promo.maxRedemptions': 'Plafond d’utilisations',
    'priceBook.promo.maxRedemptionsHint': 'Vide vaut illimité. Compté en paiements confirmés, non en paniers abandonnés.',
    'priceBook.promo.unlimited': 'Illimité',
    'priceBook.promo.spent': 'Déjà utilisé {count} fois — un plafond inférieur est refusé.',
    'priceBook.promo.statTotal': 'Codes',
    'priceBook.promo.statLive': 'Actifs',
    'priceBook.promo.statNotPricing': 'Ne tarifient pas actuellement',
    'priceBook.promo.statRedemptions': 'Utilisations',
    'priceBook.promo.activeOnly': 'Codes actifs seulement',
    'priceBook.promo.live': 'Actif',
    'priceBook.promo.notPricing': 'Ne chiffre pas',
    'priceBook.promo.withdrawn': 'Retiré',
    'priceBook.promo.withdraw': 'Retirer',
    'priceBook.promo.reinstate': 'Rétablir',
    'priceBook.promo.scope': 'S’applique à',
    'priceBook.promo.window': 'Fenêtre',
    'priceBook.promo.alwaysOn': 'Sans fenêtre',
    'priceBook.promo.redeemed': 'Utilisations',
    'priceBook.promo.ofUnlimited': '{count} sur illimité',
    'priceBook.promo.none': 'Aucun code de remise',
    'priceBook.promo.noneHint': 'Une remise est une décision commerciale avec un émetteur, une fenêtre et un plafond. Aucune n’a été prise.',

    // ─── Ce qui vous attend (§6b.2) ─────────────────────────────────────────
    'needsYou.grading': 'Évaluations à corriger',
    'needsYou.grading.what': 'Travaux remis en attente d\'un correcteur',
    'needsYou.quizMarking': 'Réponses de quiz à corriger',
    'needsYou.quizMarking.what': 'Réponses rédigées envoyées et en attente d\'un correcteur',
    'needsYou.completion': 'Certifications à délivrer',
    'needsYou.completion.what': 'Des personnes ont terminé sans être clôturées',
    'needsYou.unstaffed': 'Cohortes sans formateur',
    'needsYou.unstaffed.what': 'Au-delà du brouillon et personne d’affecté pour les enseigner',
    'needsYou.requests': 'Demandes de cohorte',
    'needsYou.requests.what': 'Des entreprises attendent une cohorte non ouverte',
    'needsYou.arrivalsCrm': 'Arrivées à admettre',
    'needsYou.arrivalsCrm.what': "Affaires gagnées en attente de vérification et d'accès",
    'needsYou.arrivalsHrm': 'Arrivées RH à admettre',
    'needsYou.arrivalsHrm.what': "Employés affectés à former ou enseigner, en attente d'accès",
    'needsYou.arrivalsAcademy': 'Adhésions à admettre',
    'needsYou.arrivalsAcademy.what': 'Adhésions achetées sur la page publique, en attente de vérification',
    // ─── Screen intros (§6d.3) ────────────────────────────────────────────
    'screen.cohortCreate.intro': 'Choisissez la version du curriculum ici — créer la cohorte la fixe et la gèle, alors choisissez avec soin avant d\'enregistrer.',
    'screen.cohortDetail.intro': 'Le registre, les séances et l\'engagement de cette cohorte réunis — ajoutez une séance ou inscrivez quelqu\'un sans quitter la fiche.',
    'screen.enrollBatch.intro': 'Inscrivez plusieurs personnes dans cette cohorte en une fois — choisissez le mode atomique ou au mieux avant de coller la liste.',
    'screen.completionBatch.intro': 'Collez des lignes d\'achèvement issues d\'un export LMS pour enregistrer la progression de plusieurs inscriptions en un seul passage.',
    'screen.grading.intro': 'Chaque travail remis en attente d\'un correcteur — confirmez une note ou renvoyez le travail sans ouvrir chaque ligne.',
    'screen.enrollmentsQueue.intro': 'Les personnes qui ont fait le travail et attendent un coordinateur — la deuxième file du tableau de bord, sous forme de liste actionnable.',
    'screen.assessmentDetail.intro': 'Un travail dans son ensemble — lisez-le, lancez les vérifications, puis confirmez la note ou renvoyez-le pour un nouvel essai.',
    'screen.credentials.intro': 'Consultez ce que détient quelqu\'un, ou délivrez une certification — choisissez d\'abord le titulaire; jamais de liste en masse.',
    'screen.credentialDetail.intro': 'Une certification telle qu\'émise — renouvelez-la, révoquez-la, ou ouvrez le même lien qu\'un employeur utiliserait pour la vérifier.',
    'screen.curriculum.intro': 'Chaque version de curriculum, épinglée ou retirée — ouvrez-en une pour modifier ses niveaux et modules avant qu\'elle ne gèle.',
    'screen.curriculumVersionDetail.intro': 'La structure de cette version se verrouille dès qu\'une cohorte l\'épingle — modifiez-la tant qu\'elle est ouverte.',
    'screen.curriculumModuleDetail.intro': 'Le code permanent de ce module, son texte modifiable, et les ensembles de dimensions et d\'outils qu\'il enseigne.',
    'screen.quizEditor.intro': 'Construisez ici les questions et options de ce quiz — réordonnez-les, puis publiez quand le module est prêt à être testé.',
    'screen.programs.intro': 'Ce que l\'Académie vend, par curriculum — ouvrez-en un pour voir ses modules et la notation qu\'exige son titre.',
    'screen.programDetail.intro': 'Les modules et normes de ce programme, et la notation des modules sur laquelle son titre est délivré.',
    // THE TESTS HR SENDS (STANDALONE-ASSESSMENTS-PLAN §1).
    'nav.assessments': 'Évaluations',
    'nav.assessments.what': 'Les tests envoyés par les RH',
    'screen.assessments.intro': 'Les tests nommés que les RH envoient — des quiz et travaux de présélection publiés, étiquetés avec les compétences mesurées.',
    'screen.assessmentEditor.intro': 'Ce que ce test dit mesurer, et de quels éléments de présélection il se compose — publiez-le pour l’offrir aux RH.',
    'assessment.create': 'Nouvelle évaluation',
    'assessment.name': 'Nom',
    'assessment.namePlaceholder': 'Revit — fondamentaux',
    'assessment.description': 'Description',
    'assessment.skills': 'Compétences mesurées',
    'assessment.skillsHint': 'Les mots que les RH lisent à côté des compétences exigées — rien ne les apparie automatiquement.',
    'assessment.skillAdd': 'Ajouter',
    'assessment.skillPlaceholder': 'Revit',
    'assessment.skillRemove': 'Retirer {skill}',
    'assessment.skillDuplicate': 'Cette compétence est déjà listée.',
    'assessment.language': 'Langue',
    'assessment.languageHint': 'Chaque élément du test doit y être rédigé.',
    'assessment.passingScore': 'Score de réussite',
    'assessment.passingScoreHint': 'Affiché aux RH à côté du résultat. Il ne décide de rien ici.',
    'assessment.timeLimit': 'Durée (minutes)',
    'assessment.timeLimitHint': 'Laissez vide pour le total des éléments.',
    'assessment.items': 'Contenu du test',
    'assessment.itemsHint': 'Quiz et travaux de présélection publiés, dans l’ordre où le candidat les rencontre. L’ordre et les retraits sont enregistrés aussitôt.',
    'assessment.itemsEmpty': 'Rien dans ce test pour l’instant.',
    'assessment.addItems': 'Ajouter des éléments',
    'assessment.addChosen': 'Ajouter {n}',
    'assessment.itemSearchPlaceholder': 'Rechercher par titre, module ou code de compétence…',
    'assessment.itemQuizMeta': '{questions} questions · {minutes} min',
    'assessment.itemTaskMeta': 'Pratique · {minutes} min',
    'assessment.itemUnpublished': 'Dépublié depuis',
    'assessment.alreadyAdded': 'Déjà ajouté',
    'assessment.roomLeft': 'Place pour {n} de plus',
    'assessment.noItems': 'Aucun élément de présélection publié dans cette langue',
    'assessment.noItemsHint': 'Les quiz et travaux de présélection sont rédigés sur le module qui enseigne la compétence, puis publiés là.',
    'assessment.searchPlaceholder': 'Rechercher par nom ou compétence…',
    'assessment.empty': 'Aucune évaluation',
    'assessment.emptyHint': 'Une évaluation est un test nommé que les RH peuvent envoyer — composez-en un à partir des quiz et travaux publiés.',
    'assessment.noMatches': 'Aucune évaluation ne correspond',
    'assessment.noMatchesHint': 'La recherche porte sur les noms et les mots de compétence.',
    'assessment.noSkills': 'Aucune compétence nommée',
    'assessment.summary': '{items} éléments · {questions} questions · {minutes} min',
    'assessment.sentCount': 'Envoyée {n} fois',
    'assessment.draft': 'Brouillon',
    'assessment.published': 'Publiée',
    'assessment.archived': 'Archivée',
    'assessment.publish': 'Publier',
    'assessment.unpublish': 'Dépublier',
    'assessment.archive': 'Archiver',
    'assessment.restore': 'Restaurer',
    'assessment.duplicate': 'Dupliquer',
    'assessment.backToList': 'Toutes les évaluations',
    'assessment.showArchived': 'Afficher les archivées',
    'assessment.standalone': 'Autonome',
    'screen.checkCodes.intro': 'Le vocabulaire fermé des constats que les correcteurs peuvent lever — vide, il signifie que les formateurs corrigent seuls.',
    'screen.priceBook.intro': 'Le prix d\'une place et les promotions en cours — deux onglets, car un prix et une remise sont deux décisions différentes.',
    'screen.enrollmentDetail.intro': 'La progression d\'un apprenant dans une cohorte — enregistrez des achèvements, dispensez un module, ou faites-le avancer.',
    'screen.instructorAvailability.intro': 'Qui est absent et quand — un tableau vide sans horodatage veut dire que personne n\'a informé, pas que personne n\'est absent.',
    'screen.people.intro': 'Toutes les personnes que l\'Académie connaît — apprenants, formateurs et personnel — cherchez ici avant d\'ouvrir une fiche.',
    'screen.personDetail.intro': 'Le profil et les certifications d\'une personne — modifiez sa fiche, placez-la dans une cohorte, ou notez son niveau.',
    'screen.companies.intro': 'Les comptes B2B et les places achetées — ouvrez-en un pour gérer ses membres ou placer des personnes dans une cohorte.',
    'screen.cohortRequests.intro': 'Des entreprises demandent une cohorte qui n\'existe pas encore — nommez la cohorte lancée, ou refusez avec un motif.',
    'screen.learnModule.intro': 'Ce module tel qu\'un apprenant le voit — leçons, devoir et quiz éventuel, avec votre progression cochée au fil de l\'eau.',
    'screen.lessonPlayer.intro': 'Une leçon, en lecture — regardez ou lisez le contenu, prenez des notes, et marquez-la terminée une fois faite.',
    'screen.my.intro': 'Vos propres inscriptions et certifications — rien ici n\'est un écran du personnel, juste vos propres registres.',
    'screen.arrivals.intro': 'Des clients convertis par, en attente de vérification — appelez pour les confirmer, puis délivrez leur accès.',
    'screen.arrivalsHrm.intro': 'Des employés que les RH ont affectés à former ou enseigner — vérifiez-les, puis délivrez l\'accès qui les démarre.',
    'screen.arrivalsAcademy.intro': 'Des adhésions achetées sur la page publique — admettez tout compte dont la création a échoué, puis délivrez l\'accès.',
    'screen.company.intro': 'Votre compte en un coup d\'œil — places, cohortes et ce que vos gens apprennent, depuis votre tableau de bord.',
    'screen.companyProgrammes.intro': 'Ce que votre compte a réellement acheté — pas le catalogue public, seulement les parcours qui vous sont ouverts.',
    'screen.companyCohorts.intro': 'Les cohortes lancées pour votre compte, liées à votre entreprise et non à qui y est inscrit — même vide, elle reste listée.',
    'screen.companyPeople.intro': 'Tous ceux que votre compte peut envoyer en formation — ajoutez quelqu\'un ou délivrez son accès depuis ici.',
    'screen.companyEnrollments.intro': 'Inscrivez vos gens dans une cohorte où vous détenez déjà une place — cela consomme une place immédiatement.',
    'screen.companyRequests.intro': 'Demandez une cohorte qui n\'existe pas encore — différent d\'une inscription, rien n\'est engagé avant la réponse.',
    'screen.companyLearning.intro': 'Ce que vos gens apprennent, une ligne par module plutôt que par personne.',
    'screen.companyReadiness.intro': 'Le verdict du moteur de compétences pour chaque place que détient votre compte.',
    'screen.companyAttendance.intro': 'Qui s\'est présenté à quelle séance, à travers toutes les cohortes gérées par votre compte.',

    // ─── Marking context, feedback and the learner's mark ──────────────────────
    'grading.feedbackToLearner': 'Commentaires pour l’apprenant',
    'grading.feedbackToLearnerHint': 'Facultatif. Affiché à côté de la note et envoyé par e-mail à l’apprenant — dites ce qui était réussi et quoi faire ensuite.',
    'grading.waitingSince': 'rendu {when}',
    'grading.handedInUnrecordedShort': 'remise non enregistrée',
    'grading.dueOn': 'à rendre le {date}',
    'learn.dueOn': 'À rendre le {date}. Votre formateur a fixé cette date pour votre promotion.',
    'learn.markedScore': 'Note : {score} %',
    'learn.markerComments': 'Les commentaires de votre formateur',
    'learn.noMarkerComments': 'Votre formateur n’a pas ajouté de commentaire.',

    // ─── Messages to learners and due dates ────────────────────────────────────
    'message.open': 'Écrire aux apprenants',
    'message.title': 'Écrire aux apprenants',
    'message.toCohort': 'Tous les apprenants actuels de la promotion {cohort} le recevront par e-mail.',
    'message.toSome': 'Envoyé par e-mail à : {names}',
    'message.subject': 'Objet',
    'message.body': 'Message',
    'message.bodyHint': 'Envoyé par l’Académie avec votre nom et votre adresse, pour que les apprenants puissent vous répondre.',
    'message.send': 'Envoyer',
    'message.sent': 'Envoyé à {count} apprenant(s).',
    'deadline.label': 'Travail à rendre le',
    'deadline.save': 'Fixer la date',
    'deadline.clear': 'Retirer',
    'deadline.hint': 'Les apprenants voient cette date ; qui n’a pas rendu son travail est relancé deux jours avant. Le retard reste accepté.',
    'deadline.dueOn': 'Le travail de ce module est à rendre le {date}.',

    // ─── The learner's home, course page and schedule ──────────────────────────
    'nav.myRecords': 'Dossiers et certificats',
    'nav.myRecords.what': 'Tous vos cours et certificats',
    'nav.schedule': 'Mon planning',
    'nav.schedule.what': 'Séances et échéances',
    'screen.myHome.intro': 'Votre prochaine leçon, les travaux à rendre ou renvoyés, et vos séances des deux prochaines semaines — au même endroit.',
    'screen.schedule.intro': 'Toutes vos séances et échéances, comme apprenant ou formateur. Ajoutez-les à votre agenda en un clic.',
    'myHome.title': 'Ma formation',
    'myHome.greeting': 'Bon retour, {name}',
    'myHome.subtitle': 'Voici quoi faire ensuite.',
    'myHome.continue': 'Continuer',
    'myHome.instructor': 'Formateur : {name}',
    'myHome.modulesDone': '{done} module(s) terminé(s) sur {total}',
    'myHome.nextLesson': 'Ensuite : {module} — {lesson}',
    'myHome.nextModule': 'Ensuite : {module}',
    'myHome.allCaughtUp': 'Vous êtes à jour. La suite dépend de votre formateur.',
    'myHome.viewCourse': 'Voir le cours',
    'myHome.askInstructor': 'Écrire à mon formateur',
    'myHome.due': 'À rendre et renvoyé',
    'myHome.nothingDue': 'Rien à rendre dans le mois qui vient, et rien ne vous a été renvoyé.',
    'myHome.sentBack': 'Renvoyé',
    'myHome.overdue': 'Était dû le {date}',
    'myHome.dueOn': 'À rendre le {date}',
    'myHome.classes': 'Séances à venir',
    'myHome.noClasses': 'Aucune séance en direct dans les deux prochaines semaines.',
    'myHome.openClass': 'Ouvrir',
    'myHome.openWork': 'Ouvrir le travail',
    'myHome.marks': 'Notes reçues',
    'myHome.readComments': 'Lire les commentaires',
    'myHome.certificates': 'Certificats',
    'myHome.certificateOnItsWay': 'Vous avez terminé {program}. Votre certificat est en préparation — nous vous écrirons dès qu’il sera délivré.',
    'myHome.certificatesHeld': 'Vous détenez {count} certificat(s) — consultez-les, partagez-les ou imprimez-les',
    'myHome.whatNext': 'Et ensuite',
    'myHome.explore': 'Découvrir d’autres programmes',
    'myHome.exploreHint': 'Voyez ce que l’Académie enseigne d’autre, et où cela mène.',
    'myHome.records': 'Mes dossiers et certificats',
    'myHome.recordsHint': 'Tous vos cours, et tous vos certificats.',
    'myHome.calendarName': 'Académie Binaa',
    'myCourse.title': 'Mon cours',
    'myCourse.runs': 'Du {from} au {to}',
    'myCourse.modules': 'Modules',
    'myCourse.standing.notStarted': 'Pas commencé',
    'myCourse.standing.inProgress': 'En cours',
    'myCourse.standing.done': 'Terminé',
    'myCourse.standing.passed': 'Réussi',
    'myCourse.standing.failed': 'À retenter',
    'myCourse.standing.waived': 'Dispensé',
    'askInstructor.title': 'Écrire à {name}',
    'askInstructor.intro': 'À propos de {program}. Votre formateur le reçoit par e-mail avec votre adresse, pour vous répondre directement.',
    'askInstructor.sent': 'Envoyé. Votre formateur répondra à votre adresse e-mail.',
    'credentialShare.copyLink': 'Copier le lien',
    'credentialShare.linkedIn': 'Ajouter à LinkedIn',
    'credentialShare.print': 'Imprimer ou enregistrer en PDF',
    'schedule.subtitle': 'Quatre semaines à la fois, comme apprenant et comme formateur.',
    'schedule.addToCalendar': 'Ajouter à l’agenda',
    'schedule.earlier': 'Plus tôt',
    'schedule.later': 'Plus tard',
    'schedule.today': 'Aujourd’hui',
    'schedule.range': '{from} – {to}',
    'schedule.emptyTitle': 'Rien de prévu sur ces quatre semaines',
    'schedule.emptyHint': 'Les séances et échéances apparaissent ici dès que vos formateurs les fixent.',
    'schedule.minutes': '{count} min',
    'schedule.dueEvent': 'À rendre : {module} ({cohort})',
    'schedule.role.learner': 'Apprenant',
    'schedule.role.instructor': 'Formateur',
    'schedule.state.Held': 'Tenue',
    'schedule.state.Cancelled': 'Annulée',
    'schedule.state.Scheduled': 'Prévue',

    // ─── The instructor's own record, registers and marking ────────────────────
    'nav.myTeaching': 'Mon enseignement',
    'nav.myTeaching.what': 'Heures, congés, retours',
    'screen.myTeaching.intro': 'Votre dossier tel que l’Académie le tient : heures, congés, registres à vérifier, et ce qu’ont dit vos apprenants.',
    'myTeaching.subtitle': 'Ce que l’Académie enregistre de votre enseignement.',
    'myTeaching.notInstructor': 'Vous n’avez pas de profil de formateur',
    'myTeaching.notInstructorHint': 'Cette page est pour les formateurs. Un coordinateur peut ajouter un profil de formateur à votre dossier.',
    'myTeaching.delisted': 'Vous ne pouvez plus prendre de nouvelles promotions depuis le {date}. Parlez de la recertification à votre coordinateur.',
    'myTeaching.hours30': 'Heures, 30 derniers jours',
    'myTeaching.hoursYear': 'Heures cette année',
    'myTeaching.hoursHint': 'D’après les séances marquées tenues — le chiffre transmis aux RH.',
    'myTeaching.sessionsYear': '{count} séances tenues',
    'myTeaching.cohorts': 'Mes promotions',
    'myTeaching.noCohorts': 'Vous n’êtes affecté à aucune promotion en cours.',
    'myTeaching.learners': '{count} apprenants',
    'myTeaching.toMark': '{count} à corriger',
    'myTeaching.registersIntro': 'Marquer une séance tenue coche tout le monde présent. Ouvrez chaque séance et décochez les absents.',
    'myTeaching.toCloseOut': 'Séances à clôturer',
    'myTeaching.toCloseOutIntro': 'Ces séances sont passées sans être marquées comme tenues : les leçons suivantes restent verrouillées tant que vous ne les clôturez pas.',
    'myTeaching.awaitingNewDate': 'Nouvel horaire à fixer',
    'myTeaching.leave': 'Mes congés',
    'myTeaching.noLeave': 'Aucun congé approuvé enregistré à partir d’aujourd’hui.',
    'myTeaching.leaveRange': '{from} – {to}',
    'myTeaching.leaveHint': 'Les congés viennent des RH une fois approuvés. S’il en manque, voyez les RH — l’Académie ne peut pas les modifier.',
    'myTeaching.comments': 'Ce qu’ont dit les apprenants',
    'myTeaching.noComments': 'Pas encore de commentaire écrit.',
    'myTeaching.standing': 'Mon statut',
    'myTeaching.certifiedOn': 'Certifié le {date}',
    'myTeaching.lastAudit': 'Dernière revue le {date} : {outcome}',
    'myTeaching.noAudit': 'Votre enseignement n’a pas encore été évalué.',
    'dashboard.registersToCheck': 'Registres à vérifier',
    'dashboard.registersToCheckHint': 'Séances tenues affichant encore tout le monde présent',
    'dashboard.attendanceUnchecked': '{count} registre(s) non vérifié(s) — comptés comme tous présents',
    'cohortSessions.registerChecked': 'Vérifié le {when}',
    'cohortSessions.registerUnchecked': 'Pas encore vérifié — tout le monde est présent jusqu’à ce que vous enregistriez ce registre.',

    'needsYou.registers': 'Registres à vérifier',
    'needsYou.registers.what': 'Séances tenues affichant encore tout le monde présent',
    'needsYou.closeOut': 'Séances à clôturer',
    'needsYou.closeOut.what': 'Séances passées non marquées comme tenues',

    // ─── Company portal: seats, people, reports, billing ───────────────────────
    'export.csv': 'Exporter vers un tableur',
    'export.completedAt': 'Terminé le',
    'export.modulesPassed': 'Modules réussis',
    'export.modulesTotal': 'Modules',
    'export.moduleCode': 'Code du module',
    'export.module': 'Module',
    'export.credits': 'Crédits',
    'export.learners': 'Apprenants',
    'export.sessionsAttended': 'Séances suivies',
    'companyImport.open': 'Importer une liste',
    'companyImport.lead': 'Collez depuis un tableur ou choisissez un fichier CSV. Colonnes : nom, e-mail, téléphone (facultatif). Une ligne d’en-têtes est acceptée.',
    'companyImport.pickFile': 'Choisir un fichier CSV',
    'companyImport.paste': 'Personnes à ajouter',
    'companyImport.placeholder': 'Layla Hassan, layla@company.com, +201000000000',
    'companyImport.preview': '{count} personne(s) prête(s) à ajouter.',
    'companyImport.submit': 'Ajouter {count} personne(s)',
    'companyImport.result': '{added} sur {total} ajouté(s). Les autres sont listés ci-dessous avec la raison.',
    'companyImport.row': 'Ligne {row}',
    'companyMember.editTitle': 'Corriger les informations',
    'companyMember.nameHint': 'En lettres latines, tel qu’il doit figurer sur le certificat.',
    'companyMember.emailLocked': 'Cette adresse sert déjà à se connecter. Demandez à votre contact de l’Académie de la changer.',
    'companyMember.remove': 'Retirer',
    'companyMember.removeTitle': 'Retirer {name} de votre compte ?',
    'companyMember.removeMessage': 'La personne quitte votre liste ; son dossier et ses certificats lui restent. Retirez-la d’abord de toute promotion en cours.',
    'company.notEnrollableWhy': 'Pas encore inscrit comme apprenant — demandez à votre contact de l’Académie.',
    'company.allOrNothing': 'Ne les inscrire que si tout le monde a une place',
    'company.goReport': 'Rapport de direction',
    'company.targetRole': 'Prépare au poste',
    'company.browseCatalogue': 'Voir tout ce qu’enseigne l’Académie',
    'company.askForQuote': 'Demander des places ou un devis',
    'companySeat.swap': 'Donner à quelqu’un d’autre',
    'companySeat.withdraw': 'Retirer',
    'companySeat.withdrawTitle': 'Retirer {name} de {cohort} ?',
    'companySeat.withdrawMessage': 'La place revient à votre compte. Le travail déjà fait reste dans son dossier.',
    'companySeat.swapTitle': 'Donner la place de {name} dans {cohort} à quelqu’un d’autre',
    'companySeat.swapLead': 'Nous vérifions que la nouvelle personne peut prendre la place avant de retirer qui que ce soit.',
    'companySeat.replacement': 'Nouvelle personne',
    'companySeat.swapConfirm': 'Transférer la place',
    'companyPerson.noSignIn': 'Ne peut pas encore se connecter',
    'companyPerson.credits': '{credits} crédits obtenus',
    'companyPerson.noCourses': 'Inscrit à aucun cours pour l’instant.',
    'companyPerson.attendance': '{attended} séance(s) suivie(s) sur {expected}',
    'companyPerson.moduleCredits': '{credits} cr',
    'companyPerson.signedOff': 'Validé par {name} le {when}',
    'companyPerson.signOff': 'Valider ce cours',
    'companyPerson.supervisorSignOff': 'Validation du tuteur',
    'companyPerson.signOffLead': 'Votre organisation accepte ce cours terminé. C’est enregistré à votre nom, sans modifier le dossier de l’Académie.',
    'companyPerson.signOffNote': 'Note (facultative), p. ex. crédits accordés',
    'companyPerson.signOffConfirm': 'Valider',
    'nav.companyCertificates': 'Certificats',
    'nav.companyCertificates.what': 'Qui détient quoi, jusqu’à quand',
    'nav.companyReport': 'Rapport',
    'nav.companyReport.what': 'Une page pour votre direction',
    'nav.companyBilling': 'Facturation',
    'nav.companyBilling.what': 'Commandes, reçus, renouvellements',
    'screen.companyCertificates.intro': 'Tous les certificats de vos équipes, chacun avec sa page publique vérifiable.',
    'screen.companyReport.intro': 'Places, heures, résultats et personnes à suivre — imprimez-le ou enregistrez-le en PDF.',
    'screen.companyBilling.intro': 'Ce que vous avez acheté à l’Académie, avec reçus, et la date de renouvellement de chaque adhésion.',
    'companyCertificates.lead': 'Les certificats de vos équipes. Partagez le lien public avec qui a besoin d’une preuve.',
    'companyCertificates.title': 'Certificat',
    'companyCertificates.link': 'Lien public',
    'companyCertificates.none': 'Pas encore de certificat',
    'companyCertificates.noneHint': 'Ils apparaissent ici à mesure que vos équipes terminent leurs programmes.',
    'companyCertificates.noExpiry': 'N’expire pas',
    'companyBilling.lead': 'Commandes payées via la caisse de l’Académie, avec reçus. Les places d’un contrat commercial figurent dans la vue d’ensemble.',
    'companyBilling.memberships': 'Adhésions et dates de renouvellement',
    'companyBilling.noMemberships': 'Aucune adhésion achetée via la caisse.',
    'companyBilling.ref': 'Référence',
    'companyBilling.plan': 'Formule',
    'companyBilling.seats': 'Places',
    'companyBilling.started': 'Début',
    'companyBilling.renews': 'Renouvellement',
    'companyBilling.orders': 'Commandes',
    'companyBilling.paid': 'Payé le',
    'companyBilling.net': 'Hors taxes',
    'companyBilling.tax': 'Taxe',
    'companyBilling.total': 'Total',
    'companyBilling.currency': 'Devise',
    'companyBilling.noOrders': 'Aucune commande',
    'companyBilling.noOrdersHint': 'Les places convenues avec notre équipe commerciale sont facturées par elle, pas ici.',
    'companyBilling.receipt': 'Reçu',
    'companyBilling.receiptTitle': 'Reçu de paiement',
    'companyBilling.billedTo': 'Facturé à',
    'companyBilling.discount': 'Remise',
    'companyBilling.taxAt': 'Taxe ({rate} %)',
    'companyBilling.receiptNote': 'Justificatif d’un paiement reçu. Pour une facture au nom de votre organisation, demandez à votre contact en citant la référence.',
    'companyRisk.title': 'À surveiller',
    'companyRisk.reasons': 'Pourquoi',
    'companyRisk.lastActive': 'Dernière activité',
    'companyRisk.none': 'Personne à surveiller : tout le monde a commencé, est actif, présent et à l’heure.',
    'companyRisk.lastActiveOn': 'Actif pour la dernière fois le {date}',
    'companyRisk.neverActive': 'Aucune activité',
    'companyRisk.attendance': 'présence {rate}',
    'companyRisk.reason.notStarted': 'Pas commencé',
    'companyRisk.reason.inactive': 'Inactif depuis 2 semaines ou plus',
    'companyRisk.reason.lowAttendance': 'Présence faible',
    'companyRisk.reason.overdue': 'Travail en retard',
    'companyRisk.reason.overdueCount': '{count} en retard',
    'companyRisk.reason.failed': 'Module échoué',
    'companyReport.lead': 'Tout ce qui suit tient sur une ou deux pages. Utilisez l’impression du navigateur pour l’enregistrer en PDF.',
    'companyReport.heading': 'Rapport de formation — {name}',
    'companyReport.asOf': 'Au {date}',
    'companyReport.investment': 'Places et personnes',
    'companyReport.outcomes': 'Résultats',
    'companyReport.delivery': 'Formation reçue',
    'companyReport.hoursDelivered': 'Heures dispensées',
    'companyReport.hoursAttended': 'Heures suivies par vos équipes',
    'companyReport.hoursScheduled': 'Heures encore prévues',
    'companyReport.sessionsHeld': 'Séances tenues',
    'companyReport.passedOf': '{passed} sur {learners} réussi(s)',
    'cohortRequest.preferredEnd': 'Début au plus tard le',
    'cohortRequest.preferredEndHint': 'Facultatif — nous donne une fenêtre plutôt qu’une date.',
    'cohortRequest.seating': 'Format',
    'cohortRequest.seating.remote': 'En ligne',
    'cohortRequest.seating.academyPremises': 'À l’Académie',
    'cohortRequest.seating.clientPremises': 'Dans nos locaux',
    'cohortRequest.language': 'Langue',
    'cohortRequest.intake': 'Équipe ou projet',
    'cohortRequest.intakeHint': 'Facultatif — le nom que vous donnez à ce groupe.',
    'cohortRequest.intakeUniversity': 'Promotion ou semestre',
    'cohortRequest.intakeUniversityHint': 'P. ex. « Printemps 2027 » ou « 3e année génie civil ».',
    'cohortRequest.withdrawn': 'Retirée',
    'cohortRequest.startBy': 'début avant le {date}',
    'cohortRequest.withdraw': 'Retirer la demande',

    // ─── /about from the database: the public showcases and the site copy ───
    'nav.siteContent': 'Textes du site public',
    'nav.siteContent.what': 'Les textes de la page publique « À propos », dans chaque langue',
    'screen.siteContent.intro': 'Remplacez l’en-tête, les résultats et les ressources de la page « À propos » ; chaque enregistrement est audité.',
    'publicSite.published': 'Publié',
    'publicSite.draft': 'Brouillon',
    'publicSite.notSetUp': 'Absent du site public',
    'publicSite.publish': 'Afficher sur le site public',
    'publicSite.publishHint': 'Uniquement avec consentement : la publication est refusée tant que la date du consentement n’est pas enregistrée ci-dessous.',
    'publicSite.consentAt': 'Consentement enregistré le',
    'publicSite.consentHint': 'La date à laquelle cette personne ou organisation a accepté d’être présentée publiquement. Requise pour publier.',
    'publicSite.slug': 'Adresse publique',
    'publicSite.slugHint': 'Minuscules, chiffres et tirets, par ex. layla-haddad.',
    'publicSite.sortOrder': 'Ordre d’affichage',
    'publicSite.tags': 'Étiquettes',
    'publicSite.tagsHint': 'Séparées par des virgules, 8 au maximum.',
    'publicSite.photo': 'Photographie',
    'publicSite.logo': 'Logo',
    'publicSite.imageHint': 'JPEG, PNG ou WebP, 5 Mo maximum.',
    'publicSite.removeImage': 'Retirer l’image',
    'publicSite.chooseImage': 'Choisir une image',
    'publicSite.dropImage': 'ou déposez-la ici',
    'publicSite.imagePending': 'Nouvelle image : {name}',
    'publicSite.imageRemoved': 'L’image sera retirée à l’enregistrement.',
    'publicSite.allLanguages': 'Rédigez-le dans les trois langues pour publier ; aucune ne remplace une autre.',
    'publicProfile.title': 'Profil public',
    'publicProfile.edit': 'Modifier le profil public',
    'publicProfile.jobTitle': 'Titre',
    'publicProfile.bio': 'Biographie',
    'publicProfile.none': 'Absent de la page publique « À propos ».',
    'publicProfile.shownAs': 'Adresse publique : {slug}',
    'showcase.action': 'Vitrine',
    'showcase.edit': 'Vitrine publique — {name}',
    'showcase.group': 'Affiché dans',
    'showcase.group.corporate': 'Clients entreprises',
    'showcase.group.academic': 'Partenaires académiques',
    'showcase.displayName': 'Nom public',
    'showcase.displayNameHint': 'Le nom sous lequel le client a accepté d’être présenté.',
    'showcase.descriptor': 'Descripteur',
    'showcase.summary': 'Ce qui a été réalisé',
    'showcase.facts': 'Chiffres',
    'showcase.factsHint': 'Jusqu’à quatre chiffres acceptés par le client, par ex. 240 / Employés formés.',
    'showcase.factValue': 'Valeur',
    'showcase.factLabel': 'Libellé',
    'showcase.addFact': 'Ajouter un chiffre',
    'siteContent.block.about.hero': 'À propos — en-tête',
    'siteContent.block.about.outcomes': 'À propos — résultats',
    'siteContent.block.about.resources': 'À propos — ressources',
    'siteContent.unwritten': 'Pas encore rédigé — la page « À propos » n’affiche rien pour ce bloc',
    'siteContent.editedAt': 'Dernier enregistrement {date}',
    'siteContent.reload': 'Charger la dernière version',
    'siteContent.saved': 'Enregistré',
    'siteContent.addRow': 'Ajouter',
    'siteContent.remove': 'Retirer',
    'siteContent.moveUp': 'Monter',
    'siteContent.moveDown': 'Descendre',
    'siteContent.field.title': 'Titre',
    'siteContent.field.lead': 'Chapeau',
    'siteContent.field.heading': 'Titre de section',
    'siteContent.field.note': 'Note',
    'siteContent.field.body': 'Texte',
    'siteContent.field.icon': 'Icône',
    'siteContent.field.tag': 'Étiquette',
    'siteContent.field.items': 'Éléments',
    'siteContent.field.groups': 'Groupes',
    // ─── Sondage de disponibilité et séances générées (SCHEDULING-PLAN A1, A2) ───
    'availability.cardTitle': 'Aidez à choisir vos horaires de cours',
    'availability.cardIntro': 'Indiquez quand vous pouvez assister. Votre formateur choisit les horaires d\'après les réponses de tous.',
    'availability.deadline': 'Répondre avant le {when}',
    'availability.zone': 'Les horaires sont dans votre fuseau : {zone}',
    'availability.answered': 'Répondu',
    'availability.notAnswered': 'Pas encore répondu',
    'availability.mark': 'Indiquer mes créneaux',
    'availability.change': 'Modifier mes réponses',
    'availability.save': 'Enregistrer mes réponses',
    'availability.saved': 'Enregistré. Vous pouvez modifier vos réponses jusqu\'à la date limite.',
    'availability.gridLabel': 'Créneaux où vous pouvez assister',
    'scheduling.title': 'Planifier les horaires de cours',
    'scheduling.intro': 'Demandez aux apprenants quand ils sont libres, puis générez les séances de la cohorte d\'après leurs réponses.',
    'scheduling.ask': 'Demander aux apprenants quand ils sont libres',
    'scheduling.generate': 'Générer les séances',
    'scheduling.lessonsWaiting': '{count} leçons en direct n\'ont pas encore de séance.',
    'scheduling.allScheduled': 'Chaque leçon en direct a déjà une séance.',
    'scheduling.lastPattern': 'Dernière génération : {rule} à {time}.',
    'scheduling.pollHeading': 'Disponibilités des apprenants',
    'scheduling.state.open': 'Ouvert',
    'scheduling.state.closed': 'Clos',
    'scheduling.state.expired': 'Expiré',
    'scheduling.state.cancelled': 'Annulé',
    'scheduling.progress': '{answered} sur {total} ont répondu',
    'scheduling.pollDeadline': 'Les réponses se closent {when}',
    'scheduling.heatmapLabel': 'Combien d\'apprenants peuvent assister à chaque créneau',
    'scheduling.zone': 'Les horaires sont dans le fuseau de la cohorte : {zone}.',
    'scheduling.busyLegend': 'Grisé : vous êtes en général occupé à ce moment (autres cours ou congé).',
    'scheduling.nobody': 'personne pour l’instant',
    'scheduling.ifNeededBy': 'si nécessaire : {names}',
    'scheduling.busyWeeks': 'Vous êtes occupé à ce moment {busy} semaines sur {weeks}.',
    'scheduling.suggestion': 'Le meilleur pour l’instant : {days} à {time}.',
    'scheduling.unanswered': 'Pas encore répondu : {names}',
    'scheduling.remind': 'Relancer les autres',
    'scheduling.reminded': 'Rappel envoyé à {count}.',
    'scheduling.remindedNone': 'Personne à relancer pour l’instant (tous ont reçu un message ces dernières 24 heures).',
    'scheduling.cancelPoll': 'Annuler le sondage',
    'scheduling.create.title': 'Demander aux apprenants quand ils sont libres',
    'scheduling.create.intro': 'Choisissez les jours et les heures dans le fuseau de la cohorte. Chaque apprenant inscrit reçoit un e-mail.',
    'scheduling.create.days': 'Jours',
    'scheduling.create.from': 'De',
    'scheduling.create.to': 'Jusqu\'à',
    'scheduling.create.duration': 'Durée du cours (minutes)',
    'scheduling.create.deadline': 'Répondre avant le',
    'scheduling.create.message': 'Message aux apprenants (facultatif)',
    'scheduling.create.mailNote': 'Un apprenant sans compte répond depuis un lien personnel dans l\'e-mail.',
    'scheduling.create.send': 'Envoyer aux apprenants',
    'scheduling.generate.title': 'Générer les séances',
    'scheduling.generate.intro': 'Choisissez le rythme. Une séance est créée pour chaque leçon en direct qui n\'en a pas, dans l\'ordre, dès le premier jour de la cohorte.',
    'scheduling.generate.prefilled': 'Prérempli avec les meilleurs créneaux des apprenants.',
    'scheduling.generate.closed': 'Cette cohorte est close : ses séances ne peuvent plus changer.',
    'scheduling.generate.time': 'Début à',
    'scheduling.generate.duration': 'Durée (minutes)',
    'scheduling.generate.zone': 'Les horaires sont dans le fuseau de la cohorte ({zone}).',
    'scheduling.generate.holidays': 'Dates à ignorer (jours fériés)',
    'scheduling.generate.addHoliday': 'Ignorer cette date',
    'scheduling.generate.unskip': 'Ne plus ignorer {date}',
    'scheduling.generate.skipDate': 'Ignorer {date}',
    'scheduling.generate.notify': 'Envoyer aux apprenants leur calendrier par e-mail',
    'scheduling.generate.integrated': 'Tenir les cours dans la classe virtuelle de l\'Académie',
    'scheduling.generate.preview': 'Aperçu',
    'scheduling.generate.save': 'Créer {count} séances',
    'scheduling.generate.noDates': 'Ce rythme ne donne aucune date avant la fin de la cohorte.',
    'scheduling.generate.colDate': 'Date',
    'scheduling.generate.colTime': 'Heure',
    'scheduling.generate.colLesson': 'Leçon',
    'scheduling.generate.flag.instructorAbsent': 'Formateur absent',
    'scheduling.generate.flag.holiday': 'Ignorée',
    'scheduling.generate.flag.extraOccurrence': 'Plus de leçon',
    'scheduling.generate.flag.instructorBusy': 'Autre cours à ce moment',
    'scheduling.generate.extra': '…et {count} autres dates sans leçon.',
    'scheduling.generate.unplaced': 'Pas de date pour : {lessons}. Élargissez le rythme ou repoussez la date de fin.',
    'scheduling.generate.done': '{count} séances créées, {mailed} apprenants ont reçu leur calendrier.',

    // ── HR's screening test page (screens/screening/ScreeningTestPage.jsx) ──
    'screenTest.title': 'Évaluation des compétences',
    'screenTest.greeting': 'Bonjour {name},',
    'screenTest.intro': 'Notre équipe RH vous a envoyé cette évaluation pour mesurer les compétences que demande le poste.',
    'screenTest.timeLimit': 'Durée : {minutes} minutes',
    'screenTest.startBy': 'À commencer avant le {date}',
    'screenTest.rules.title': 'Avant de commencer',
    'screenTest.rules.once': 'Vous ne pouvez la passer qu’une fois.',
    'screenTest.rules.device': 'Utilisez un seul appareil et un seul navigateur du début à la fin. Une fois commencée, le lien ne fonctionne plus ailleurs.',
    'myAssessments.title': 'Évaluations de compétences',
    'myAssessments.subtitle': 'Les tests que les RH vous ont demandé de passer. Vos résultats vont aux RH, pas sur cette page.',
    'myAssessments.linkHint': 'Les tests de compétences envoyés par les RH',
    'myAssessments.toTake': 'Évaluations de compétences à passer',
    'myAssessments.empty': 'Aucune évaluation',
    'myAssessments.emptyHint': 'Quand les RH vous envoient un test de compétences, il apparaît ici.',
    'myAssessments.startBy': 'À commencer avant le {date} · {minutes} minutes',
    'myAssessments.endsAt': 'En cours · se termine le {date}',
    'myAssessments.submittedOn': 'Remis le {date}',
    'myAssessments.status.ready': 'À passer',
    'myAssessments.status.inProgress': 'En cours',
    'myAssessments.status.submitted': 'Remis',
    'screenTest.rules.timer': 'Le chronomètre démarre quand vous appuyez sur Commencer et ne s’arrête pas. À la fin du temps, ce que vous avez enregistré est envoyé.',
    'screenTest.rules.autosave': 'Vos réponses sont enregistrées au fur et à mesure.',
    'screenTest.section.quiz': 'Questions',
    'screenTest.section.task': 'Tâche pratique',
    'screenTest.section.minutes': 'environ {minutes} min',
    'screenTest.section.questions': '{count} questions',
    'screenTest.start': 'Commencer l’évaluation',
    'screenTest.timeLeft': 'Temps restant',
    'screenTest.saving': 'Enregistrement…',
    'screenTest.saved': 'Toutes les réponses sont enregistrées',
    'screenTest.saveFailed': 'Pas encore enregistré. Vérifiez votre connexion ; nous réessayons.',
    'screenTest.points': '{points} pt',
    'screenTest.chooseOne': 'Choisissez une réponse.',
    'screenTest.chooseMany': 'Choisissez toutes les réponses qui conviennent.',
    'screenTest.answer': 'Votre réponse',
    'screenTest.chars': '{used} / {max} caractères',
    'screenTest.task.answer': 'Votre réponse',
    'screenTest.task.link': 'Lien vers votre travail',
    'screenTest.task.linkHint': 'Une adresse complète commençant par https://',
    'screenTest.task.file': 'Votre fichier',
    'screenTest.task.upload': 'Téléverser un fichier',
    'screenTest.task.replace': 'Remplacer le fichier',
    'screenTest.task.uploaded': 'Téléversé : {name}',
    'screenTest.task.uploading': 'Téléversement… {percent} %',
    'screenTest.task.uploadFailed': 'Le téléversement a échoué. Réessayez.',
    'screenTest.task.uploadsOff': 'Le téléversement est indisponible pour le moment. Contactez la personne qui vous a envoyé cette évaluation.',
    'screenTest.submit': 'Envoyer l’évaluation',
    'screenTest.submitConfirm': 'Envoyer maintenant ? Vous ne pourrez plus modifier vos réponses.',
    'screenTest.submitYes': 'Oui, envoyer',
    'screenTest.submitNo': 'Continuer',
    'screenTest.timeUp': 'Le temps est écoulé. Envoi de ce que vous avez enregistré…',
    'screenTest.done.title': 'Merci. Votre évaluation a été envoyée.',
    'screenTest.done.body': 'Notre équipe RH vous contactera pour la suite. Vous pouvez fermer cette page.',
    'screenTest.done.auto': 'Le temps étant écoulé, les réponses enregistrées ont été envoyées.',
    'screenTest.dead.title': 'Ce lien n’est pas valide',
    'screenTest.dead.body': 'Il a peut-être expiré, été remplacé, déjà été utilisé ou été ouvert sur un autre appareil. Contactez la personne qui vous l’a envoyé.',
    'screenTest.error': 'Une erreur s’est produite. Vérifiez votre connexion et réessayez.',
    'screenTest.retry': 'Réessayer',

    // ── HR's screening marking (screens/grading/Screening*) ──
    'grading.screeningTab': 'Évaluations RH',
    'grading.screening.intro': 'Les évaluations RH, corrigées à l’aveugle : vous voyez le travail et une référence, jamais le nom.',
    'grading.screening.empty': 'Rien à corriger',
    'grading.screening.emptyHint': 'Les réponses rédigées et les tâches pratiques des évaluations RH apparaissent ici une fois envoyées.',
    'grading.screening.reference': 'Réf. {reference}',
    'grading.screening.kindQuiz': 'Réponses rédigées',
    'grading.screening.kindTask': 'Tâche pratique',
    'grading.screening.aiDrafted': 'Brouillon IA prêt',
    'grading.screening.quizTitle': 'Corriger un quiz d’évaluation',
    'grading.screening.taskTitle': 'Corriger une tâche pratique',
    'grading.screening.correction': 'Correction',
    'grading.screening.askAi': 'Demander un brouillon à l’IA',
    'grading.screening.aiDraftBadge': 'Brouillon IA',
    'grading.integrity.title': 'Signaux d\'intégrité',
    'grading.integrity.noFlags': 'Aucun signalement',
    'grading.integrity.flag.fastFinish': 'Terminé très vite',
    'grading.integrity.flag.leftPage': 'A souvent quitté la page',
    'grading.integrity.flag.copiedFromPage': 'A copié depuis la page',
    'grading.integrity.flag.pastedAnswers': 'Réponses collées',
    'grading.integrity.timeTaken': 'Temps passé',
    'grading.integrity.timeWriting': 'Temps avec l\'éditeur ouvert',
    'grading.integrity.durationOfLimit': '{minutes} min {seconds} s sur {limit} min',
    'grading.integrity.duration': '{minutes} min {seconds} s',
    'grading.integrity.autoSubmitted': 'remis à la fin du temps',
    'grading.integrity.leftPage': 'A quitté la page',
    'grading.integrity.copied': 'Copié depuis la page',
    'grading.integrity.pasted': 'Collé dans les réponses',
    'grading.integrity.timesSeconds': '{count} fois, {seconds} s au total',
    'grading.integrity.timesChars': '{count} fois, {chars} caractères',
    'grading.integrity.notRecorded': 'La page n\'a pas enregistré de signaux pour ce travail (passé avant le début de l\'enregistrement, ou bloqué par le navigateur).',
    'grading.integrity.weighNote': 'À apprécier par vous, jamais une note en soi. La personne évaluée n\'est pas informée de cet enregistrement.',
    'grading.integrity.answerPasted': '{pasted} caractères collés sur {chars}',
    'grading.integrity.aiLeftToYou': 'L\'IA vous a laissé ce travail à noter.',
    'grading.integrity.aiFailedBadge': 'L\'IA n\'a pas pu noter',
    'grading.integrity.flagsBadge': '{count} signalement(s)',
    'grading.screening.brief': 'La tâche',
    'grading.screening.handedIn': 'Remis',
    'grading.screening.aiScore': 'Note proposée : {score} / 100',
    'grading.screening.aiNoScore': 'Aucune note proposée : pas assez d’éléments.',
    'grading.screening.aiNoFile': 'L’IA n’a lu que la réponse rédigée et le lien, pas le fichier.',
    'grading.screening.scoreLabel': 'Note (0–100)',
};
